var waitForJQuery = setInterval(function () {
    if (typeof $ != 'undefined') {
        console.log('loaded jquery')
        // place your code here.
        clearInterval(waitForJQuery);
        initApp();
    } else {
        console.log('waiting for jquery')
    }
}, 50);

var initQuickViewEvents = function() {
    $('.product-quickview').find('.description').on('click', function(){
        $(this).addClass('is-expanded');
    })

    var setQvCarousel = new window.swiper("#quickviewThumbs", {
        slidesPerView: 1,
        spaceBetween: 20,
        breakpoints: {
            768: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
        },
        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    });
}

function getRecommendedProducts() {
    var cartItemId = $('.js-minicart-item').attr('data-product-id');

    const url = "/recommendations/products?section_id=product-recommendations-qf&product_id=" + cartItemId + "&limit=30";

    if (cartItemId) {
        $.ajax({
            url: url,
            type: 'get',
            success: function (itemData) {
                var $carousel = $(itemData).html();
                // setRecommendedProducts(itemData);
                $('#minicartUpsellMakeASet .freq-desktop-cart').html(itemData).removeClass('is-invisible');
                $('#minicartUpsellMakeASet').removeClass('is-hidden');

                var freq_swiper = new window.swiper(".product-recommendations-qf", {
                    slidesPerView: 1.2,
                    spaceBetween: 16,
                    breakpoints: {
                        768: {
                            slidesPerView: 1.2,
                            spaceBetween: 16,
                        },
                    },
                    loop: false,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    }
                });

                $('.swiper-arrow').on('click', function(f){
                    f.preventDefault();
                    freq_swiper.slideNext();
                })               
                $('.js-makeset-additem').on('click', function(f){

                    f.preventDefault();

                    var $parent = $(this).parents('.freq-product-card'),
                        activeId = $parent.find('.js-minicart-upsell-sizes').find("option:selected").attr("data-variant-id");

                    window.qf_cart.addToCart(activeId, 1);
                })
                cartUpsellItemsMultiBuyPrice();
            }
        });
    } else {
        $('#minicartUpsellMakeASet .freq-desktop-cart').removeClass('is-invisible');
    }

}

function cartMultiBuyProgressHeader() {
    const allPills = document.querySelectorAll('.js-cart-wrapper .multi-buy-progress-pill');
    const multibuyCartItems = document.querySelectorAll('.multibuy-cart-item');
    if(multibuyCartItems.length === 0) return;
    // Remove existing header to avoid duplicates when called from both cart_rendered and side_cart_opened
    document.querySelectorAll('.js-cart-wrapper .multi-buy-header').forEach(function(el) { el.remove(); });
    const multiBuyHeader = document.createElement('div');
    if (window.themeSettings.enableKnickerMultibuy == false) {
       multiBuyHeader.classList.add('multi-buy-header', 'is-hidden');
    }else{
       multiBuyHeader.classList.add('multi-buy-header');
    }
    multiBuyHeader.style.order = 1;
    multiBuyHeader.innerHTML = `<h4> <svg width="8" height="9" viewBox="0 0 8 9" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="4" cy="4.5" r="4" fill="currentColor"></circle></svg>Knicker Picker</h4> <h4 class="multi-buy-progress-text"></h4>`      
    multibuyCartItems[multibuyCartItems.length - 1].after(multiBuyHeader)
    const totalQtyCart = parseInt(document.querySelector('.js-cart-wrapper .total-knicker-qty')?.dataset.totalKnickerQty, 10) || 0;
    const progressText = multiBuyHeader.querySelector('.multi-buy-progress-text');

    allPills.forEach((pill, index)=> {
        const miletstoneQty = parseInt(pill.dataset.milestoneQty);
        if(totalQtyCart >= miletstoneQty) {

            if(index >= allPills.length - 1) {
                const finalPrice = parseFloat(pill?.dataset.milestonePrice).toFixed(2);
                const currentPercentage = parseInt(pill?.dataset.milestonePercentage);
                progressText.textContent = `You're saving ${currentPercentage}%`;
                return;
            }
            const nextMilestone = parseInt(allPills[index + 1]?.dataset.milestoneQty);
            const nextMilestonePrice = parseFloat(allPills[index + 1]?.dataset.milestonePrice).toFixed(2);
            const nextMilestonePercentage = parseInt(allPills[index + 1]?.dataset.milestonePercentage);
            const nextTargetMilestone = nextMilestone - totalQtyCart
            progressText.textContent = `Add ${nextTargetMilestone} more & save ${nextMilestonePercentage}%`;
            }
    })
}

function cartUpsellItemsMultiBuyPrice() {
    const upsellItems = document.querySelectorAll('.multibuy-upsell-item .freq-product-price');
    const allPills = document.querySelectorAll('.js-cart-wrapper .multi-buy-progress-pill');
    const multiBuy = document.querySelector('multi-buy')
    const currencySymbol = multiBuy?.dataset.currencySymbol || '£';
    const totalKnickerQty = parseInt(document.querySelector('.total-knicker-qty')?.dataset.totalKnickerQty);
    let currentProgressPrice = parseFloat(allPills[0]?.dataset.milestonePrice).toFixed(2);
    allPills.forEach((pill, index)=> {
      const milestoneQty = parseInt(pill.dataset.milestoneQty);
      if(totalKnickerQty >= milestoneQty) {
        currentProgressPrice = parseFloat(pill.dataset.milestonePrice).toFixed(2);
      }
    })
    if (upsellItems.length > 0) {
      upsellItems.forEach((item)=> {
        const priceItem = item.querySelector('.freq-price-item')
        const ogPrice = item.dataset.price;
        const ogRawPrice = parseFloat(item.dataset.rawPrice).toFixed(2);
        if(currentProgressPrice < ogRawPrice) {
            const strikethroughPrice = item.querySelector('.item-discount');
            strikethroughPrice.textContent = ogPrice;
        }
        priceItem.textContent = currencySymbol + currentProgressPrice.replace('.00', '');
      })
    }
}
var cartEventsInitialized = false

function initMakeSetCartEvents() {
    if (!cartEventsInitialized) {
        $('.js-makeset-additem').on('click', function(f){
            f.preventDefault();

            var $parent = $(this).parents('.freq-product-card'),
                activeId = $parent.find('.js-minicart-upsell-sizes').find("option:selected").attr("data-variant-id");

            window.qf_cart.addToCart(activeId, 1);
        })

    }

}

function setRecommendedProducts(node) {
    var productRecommendations = $('#product-recommendations-qf .product-recommendations-2').html(),
        isMakeSet = $('.cart-frequently-bought-desktop').attr('data-makeset');

    if (isMakeSet == "false") {
        $('.cart-frequently-bought-desktop').html(node);
        $('#minicartUpsellMakeASet').removeClass('is-hidden');
    }

    initCartCarousel();
    initMinicartSetProductsCarousel();

    initMakeSetCartEvents();
   
}

function initMinicartEvents() {
    window.addEventListener('side_cart_opened', function (e) {
        // Update multi-buy progress message when cart drawer opens (e.g. after page reload)
        cartMultiBuyProgressHeader();
    })

    initMakeSetCartEvents();

    window.addEventListener('cart_rendered', function (e) {
        var isMakeSet = $('.cart-frequently-bought-desktop').attr('data-makeset'),
            $amountToSpend = $('#amount-to-spend'),
            isCartNotEmpty = $('.js-minicart-item').length;

        // remove floating zeros
        if ($amountToSpend.length > 0) {
            var newAmount = $amountToSpend.html().replace('.00', '');
            $amountToSpend.html(newAmount);
        }

        if (isMakeSet == "true" || isCartNotEmpty === 0) {
            $('#minicartUpsellMakeASet').removeClass('is-hidden');
        }

        getRecommendedProducts();
        initCartCarousel();
        initMinicartSetProductsCarousel();

        initMakeSetCartEvents();
        cartMultiBuyProgressHeader();
    });

    // Update multi-buy message when cart quantity changes via +/- in cart drawer
    window.addEventListener('cart_changed', function (e) {
        setTimeout(function () {
            cartMultiBuyProgressHeader();
        }, 400);
    });
}

function initCustomFilterEvents() {
    $('.js-mobile-filter-heading').on('click', function(){
        $(this).toggleClass("active")
    })
}

function initRecommendedProducts(recommendedUrl) {
    var $recommendations = $('.product-recommendations');
    $recommendations.attr('data-url', recommendedUrl);

    $.ajax({
        url: recommendedUrl,
        type: 'get',
        success: function (itemData) {
            $recommendations.html(itemData)
        }
    });
}

function initPdpTabs() {
    var swatchesGroups = [],
        currentSwatchGroup = $('.js-swatch_wrapper.current').data('colour-group'),
        $tabs = $('#colourwaysTabs'),
        swatchesLimitToShowTabs = 16,
        numTabItems = $('.js-swatch_wrapper').length;

    if (numTabItems > swatchesLimitToShowTabs) {
        $('.js-swatch_wrapper').each(function(){
            var colourGroup = $(this).data('colour-group');

            if (swatchesGroups.indexOf(colourGroup) < 0 && colourGroup != "") {
                swatchesGroups.push(colourGroup);

                // $tabs.append('<div class="js-swatches-tabs swatches-tabs" data-colour="' + colourGroup + '">' + colourGroup + '</div>');
            }
        })

        $('.js-swatches-tabs').on('click', function(){
            var $this = $(this),
                tabName = $(this).attr('data-colour');

            $this.siblings().removeClass('is-active');
            $this.addClass('is-active');

            $('.js-swatch_wrapper').addClass('is-hidden');
            $('.js-swatch_wrapper[data-colour-group="' + tabName + '"]').removeClass('is-hidden');

            $(document).trigger('colorways:tabChanged');
        })

        // Move sale to last position
        // $('.js-swatches-tabs[data-colour="Sale"]').appendTo('#colourwaysTabs');


        // Hide tabs if no groups list
        if (swatchesGroups.length == 0 || swatchesGroups.length == 1) {
            $('#colourwaysTabs').addClass('is-hidden');
        } else {
            if (currentSwatchGroup != "") {
                $('.js-swatches-tabs[data-colour="' + currentSwatchGroup + '"]').trigger('click');
            } else {
                $('.js-swatches-tabs').first().trigger('click');
            }
        }

    } else {
        $('#colourwaysTabs').addClass('is-hidden');
    }

    $('#colorwaysType').removeClass('is-hidden');

}

function initSwatchCollapse() {
    var $container = $('#colorwaysType');
    var $toggle = $('.js-swatches-collapse-toggle');
    if (!$container.length || !$toggle.length) return;

    var isExpanded = false;
    var ROW_TOLERANCE = 3; // px — same-row detection threshold

    function getVisibleSwatches() {
        return $container.find('.js-swatch_wrapper:not(.is-hidden)');
    }

    function measureFirstRow() {
        var $sw = getVisibleSwatches();
        if (!$sw.length) return { height: 0, count: 0 };

        var containerTop = $container[0].getBoundingClientRect().top;
        var firstRect = $sw[0].getBoundingClientRect();
        var firstRowTop = firstRect.top;
        var firstRowBottom = firstRect.bottom;
        var count = 0;

        $sw.each(function() {
            var r = this.getBoundingClientRect();
            if (r.top < firstRowTop + ROW_TOLERANCE) {
                count++;
                firstRowBottom = Math.max(firstRowBottom, r.bottom);
            } else {
                return false;
            }
        });

        return { height: Math.ceil(firstRowBottom - containerTop), count: count };
    }

    function applyCollapse() {
        $container.css({ 'max-height': '', 'overflow': '' });

        var $sw = getVisibleSwatches();
        var total = $sw.length;

        if (!total) {
            $toggle.removeClass('is-visible');
            return;
        }

        var firstRow = measureFirstRow();
        var hiddenCount = total - firstRow.count;

        if (hiddenCount <= 0) {
            $toggle.removeClass('is-visible');
            isExpanded = false;
            return;
        }

        // Auto-expand if the selected swatch is in a hidden row
        var $current = $container.find('.js-swatch_wrapper.current:not(.is-hidden)');
        var shouldAutoExpand = false;
        if ($current.length) {
            var curTop = $current[0].getBoundingClientRect().top;
            shouldAutoExpand = curTop > $sw[0].getBoundingClientRect().top + ROW_TOLERANCE;
        }

        if (shouldAutoExpand) {
            isExpanded = true;
            $toggle
                .text('SHOW LESS')
                .addClass('is-visible is-expanded')
                .attr('aria-expanded', 'true');
        } else {
            isExpanded = false;
            // Suppress transition so the initial collapse (and tab switches) are instant
            $container.css('transition', 'none');
            $container.css({ 'overflow': 'hidden', 'max-height': (firstRow.height + 2) + 'px' });
            $container[0].offsetHeight; // force reflow before restoring transition
            $container.css('transition', '');
            $toggle
                .html('SHOW MORE <span class="js-swatches-collapse-count">' + hiddenCount + '</span>+')
                .addClass('is-visible')
                .removeClass('is-expanded')
                .attr('aria-expanded', 'false');
        }
    }

    function animateExpand() {
        var fullHeight = $container[0].scrollHeight;
        $container.css({ 'overflow': 'hidden', 'max-height': fullHeight + 'px' });
        isExpanded = true;
        $toggle
            .text('SHOW LESS')
            .addClass('is-expanded')
            .attr('aria-expanded', 'true');
        setTimeout(function() {
            if (isExpanded) {
                $container.css({ 'max-height': '', 'overflow': '' });
            }
        }, 320);
    }

    function animateCollapse() {
        var $sw = getVisibleSwatches();
        var total = $sw.length;
        var firstRow = measureFirstRow();
        var hiddenCount = total - firstRow.count;

        // Snap to full height (no transition) then animate down
        var fullHeight = $container[0].scrollHeight;
        $container.css({ 'overflow': 'hidden', 'max-height': fullHeight + 'px' });
        $container[0].offsetHeight; // force reflow
        $container.css('max-height', (firstRow.height + 2) + 'px');

        isExpanded = false;
        $toggle
            .html('SHOW MORE <span class="js-swatches-collapse-count">' + hiddenCount + '</span>+')
            .removeClass('is-expanded')
            .attr('aria-expanded', 'false');
    }

    $toggle.on('click', function() {
        if (isExpanded) {
            animateCollapse();
        } else {
            animateExpand();
        }
    });

    $(document).on('colorways:tabChanged', function() {
        applyCollapse();
    });

    applyCollapse();
}

function initPdpSwatches() {
    var upsellType = $('#colorwaysType').data('upsell-type');

    var getSizeLabel = function(label, id, inventory, inventoryPolicy, hideNotify) {
        var labelName = label.toUpperCase(),
            shopCurrency = $('#variantRadioWrapper').attr('data-shop-currency'),
            labelClass = "";

        if (inventory < 1 && inventoryPolicy !== "continue") {
            labelClass = "disabled"
        }


        if (labelName == "XS") {
            if (shopCurrency == "GBP") {
                labelName = "<b>XS</b><div class='product-size-conversion'>(6-8)</div>"           
            } else {
                labelName = "<b>XS</b><div class='product-size-conversion'>(2-4)</div>"
            }
        } else if (labelName == "S") {
            if (shopCurrency == "GBP") {
                labelName = "<b>S</b><div class='product-size-conversion'>(8-10)</div>"
            } else {
                labelName = "<b>S</b><div class='product-size-conversion'>(4-6)</div>"
            }

        } else if (labelName == "M") {
            if (shopCurrency == "GBP") {
                labelName = "<b>M</b><div class='product-size-conversion'>(10-12)</div>"
            } else {
                labelName = "<b>M</b><div class='product-size-conversion'>(6-8)</div>"
            }
        } else if (labelName == "L") {
            if (shopCurrency == "GBP") {
                labelName = "<b>L</b><div class='product-size-conversion'>(12-14)</div>"
            } else {
                labelName = "<b>L</b><div class='product-size-conversion'>(8-10)</div>"
            }
        } else if (labelName == "1X") {
            if (shopCurrency == "GBP") {
                labelName = "<b>1X</b><div class='product-size-conversion'>(14-16)</div>"
            } else {
                labelName = "<b>L</b><div class='product-size-conversion'>(10-12)</div>"
            }
        } else if (labelName == "2X") {
            if (shopCurrency == "GBP") {
                labelName = "<b>2X</b><div class='product-size-conversion'>(16-18)</div>"
            } else {
                labelName = "<b>2X</b><div class='product-size-conversion'>(12-14)</div>"
            }
        } else if (labelName == "3X") {
            if (shopCurrency == "GBP") {
                labelName = "<b>3X</b><div class='product-size-conversion'>(18-20)</div>"
            } else {
                labelName = "<b>3X</b><div class='product-size-conversion'>(16-18)</div>"
            }
        } else if (labelName == "4X") {
            if (shopCurrency == "GBP") {
                labelName = "<b>4X</b><div class='product-size-conversion'>(20-22)</div>"
            } else {
                labelName = "<b>4X</b><div class='product-size-conversion'>(18-20)</div>"
            }
        }

        labelName = "<label data-hidenotify='" + hideNotify + "' class='" + labelClass + "' data-stock-amount='" + inventory + "' for='radio-" + id +"'><div>" + labelName + "</div></label>"

        if (inventory < 1 && inventoryPolicy !== "continue") {
            labelName = labelName + '<div class="oos-strikethrough"></div>';
        }

        return labelName;
    };

    var getVariantInput = function(id, inventory, price, inventoryPolicy, label, productMasterId, hideNotify) {
        var dataStock = "true";

        if (inventory < 1) {
            dataStock = "false"
        }

        var inputNode = "<input data-hidenotify='" + hideNotify + "' class='variant-radios' data-productmasterid='" + productMasterId + "' data-productid='" + id + "' type='radio' id='radio-" + id + "' name='id' value='" + id + "' data-inventory-policy='" + inventoryPolicy + "' data-title='" + label + "' data-stock='" + dataStock + "' data-price='" + price + "' data-stock-amount='" + inventory + "' />";

        return inputNode;
    };

    var setThumbnailLabel = function(labelsList) {
        var raw = labelsList || '';
        var items = [];
        raw.split(';').forEach(function(item) {
            if ($.trim(item)) {
                var parts = item.split(':');
                var text = $.trim(parts[0]);
                var idx = parseInt($.trim(parts[1]), 10) - 1;
                if (!isNaN(idx)) {
                    items.push({ text: text, idx: idx });
                }
            }
        });

        // collect all image containers in DOM order
        var $containers = $('.js-desktop-images-wrapper .js-zoom-container');

        // remove existing captions
        $containers.find('.product-img-caption').remove();

        // inject new captions
        items.forEach(function(obj) {
            var $container = $containers.eq(obj.idx);
            if ($container.length) {
                // console.log('adding label', $container);
                var $p = $('<div>').addClass('product-img-caption').text(obj.text);
                $container.append($p);
            }
        });


        $('#gallery-swiper').find('.product-img').each(function(index){
            var labelSplitted = labelsList.split(';'),
                $label = $(this).find('.swiper-zoom-container').find('.product-img-caption');

            // reset all labels
            $label.addClass('is-hidden');

            $.each(labelSplitted, function(index2, labelItem) {
                if (labelItem) {
                    var labelItemSplitted = labelItem.split(':'),
                        labelContent = labelItemSplitted[0],
                        labelOrder = parseInt(labelItemSplitted[1]);

                    if (labelOrder == index) {
                        $label.html(labelContent).removeClass('is-hidden');
                    }
                }
            });
        })

            // Update size-caption based on current gallery slide (same logic as product-img-caption)
            try {
                var swiperEl = document.querySelector('.gallery-swiper');
                if (swiperEl && swiperEl.swiper) {
                    // Use same index logic as product-img-caption: activeIndex (0-based) matches labelOrder (1-based)
                    var currentIndex = swiperEl.swiper.activeIndex || 0;
                    var captionText = '';
                    var partsList = (labelsList || '').split(';');
                    $.each(partsList, function(i, item){
                        if (item) {
                            var parts = item.split(':'),
                                text = $.trim((parts[0] || '')),
                                order = parseInt($.trim((parts[1] || '')), 10);
                            // Match the same logic as product-img-caption: order == index (0-based)
                            if (order == currentIndex) { captionText = text; }
                        }
                    });
                    // Always set caption text (empty if no match found)
                    var $sizeCaption = $('.size-caption');
                    if ($sizeCaption.length > 0) {
                        $sizeCaption.text(captionText);
                    }
                }
            } catch(e) { if (console && console.warn) { console.warn('setThumbnailLabel caption sync error', e); } }
    }

	// Fetch and refresh the PDP review overlay content for a new product URL (expects `?view=review-overlays`)
	var updateReviewOverlay = function(productUrlWithView) {
		try {
			if (console && console.log) {
				console.log('updateReviewOverlay called with URL:', productUrlWithView);
			}
			if (!productUrlWithView) { return; }
			axios.get(productUrlWithView)
				.then(function (response) {
					var tempContainer = document.createElement('div');
					tempContainer.innerHTML = response.data;
					var incomingWrapper = tempContainer.querySelector('.pdp-review-overlay-wrapper');
					var currentWrapper = document.querySelector('.pdp-review-overlay-wrapper');
					if (incomingWrapper && currentWrapper) {
						currentWrapper.replaceWith(incomingWrapper);
						var overlayEl = document.querySelector('.review-overlay-swiper');
						if (overlayEl && window.swiper) {
							new window.swiper('.review-overlay-swiper', {
								slidesPerView: 1,
								spaceBetween: 0,
								loop: false,
								autoplay: {
									delay: 3000,
									disableOnInteraction: false,
								}
							});
						}
						
						// Update overlay content for the new product (mobile only) - optimized
						if (window.innerWidth <= 769) {
							// Get current thumbnail label for the new product
							var newThumbnailLabel = $('.js-swatch_wrapper.current').data('thumbnail-label') || '';
							if (newThumbnailLabel) {
								// Update the global thumbnail label
								if (window.updateOverlayContent) {
									// Update the thumbnail label in the global scope
									var swiperEl = document.querySelector('.gallery-swiper');
									if (swiperEl && swiperEl.swiper) {
										// Store the new thumbnail label for the updateOverlayContent function
										swiperEl.swiper.thumbnailLabel = newThumbnailLabel;
									}
									// Call the global update function immediately
									window.updateOverlayContent();
								}
							} else {
								// If no thumbnail label, hide the overlay completely
								$('.pdp-review-overlay-wrapper').addClass('is-hidden').hide();
							}
						}
					}
				})
				.catch(function (err) {
					if (console && console.warn) { console.warn('Failed to update review overlays', err); }
				});
		} catch (e) {
			if (console && console.warn) { console.warn('updateReviewOverlay error', e); }
		}
	}

    var resetThumbnailLabel = function() {
        $('#gallery-swiper').find('.product-img').each(function(index){
            var $label = $(this).find('.swiper-zoom-container').find('.product-img-caption');

            $label.addClass('is-hidden');
        });
         var $sizeCaption = $('.size-caption');
         if ($sizeCaption.length > 0) {
             $sizeCaption.text('');
         }
    }

    var setMultiItemsPrices = function(price, priceCompare) {
        var $wrapper = $('.js-product-multiple-add'),
            reductionAmount = $wrapper.data('reduction-amount'),
            currencySymbol = $wrapper.data('currency'),
            itemPrice = parseFloat(price.match(/\d+/g)),
            isDiscountedItem = priceCompare ? true : false;

        if (isDiscountedItem) {
            $('.js-addtocart-multiple').each(function(){
                var $this = $(this),
                    quantity = parseInt($this.data('quantity')),
                    $price = $this.find('.js-product-multiple-add-prices'),
                    totalPrice = itemPrice * quantity,
                    priceNode = "<span>" + currencySymbol + totalPrice + "</span>";
                console.log(totalPrice, itemPrice, quantity)
                $price.html(priceNode);
            })
        } else {
            $('.js-addtocart-multiple').each(function(){
                var $this = $(this),
                    quantity = parseInt($this.data('quantity')),
                    $price = $this.find('.js-product-multiple-add-prices'),
                    priceReduction = parseFloat(parseInt($('.js-product-multiple-add').data('price-reduction'))/100),
                    newPrice = itemPrice;

                if (quantity > 2) {
                    var oldPrice = newPrice,
                        newPrice = itemPrice - priceReduction,
                        totalPrice = newPrice * quantity,
                        totalPriceNew = parseFloat(totalPrice).toFixed(2),
                        totalPriceOld = oldPrice * quantity,
                        priceNode = "<span style='text-decoration:line-through;'>" + currencySymbol + totalPriceOld + "</span> <span> " + currencySymbol + totalPriceNew + "</span>";

                } else {
                    var totalPrice = newPrice * quantity,
                        priceNode = "<span>" + currencySymbol + totalPrice + "</span>";
                }


                $price.html(priceNode);
            })
        }
    }

    $('.js-swatch_wrapper').on('mouseenter', function() {
        // Get the data-images-thumb attribute
        var imageUrls = $(this).data('images-thumb').split(';');

        // Prefetch images
        imageUrls.forEach(function(url) {
            // Create a new Image object and set the source to prefetch the image
            var img = new Image();
            img.src = $.trim(url);  // Remove any extra spaces
        });
    });

    $('.js-swatch_wrapper').on('click', function(){
        var $this = $(this),
            productId = $this.data('productid'),
            title = $this.data('title'),
            subtitle = $this.data('subtitle'),
            price = $this.data('price'),
            rawPrice = $this.data('raw-price'),
            href = $this.attr('href'),
            hideNotify = $this.data('hide-notifyme'),
            showMultipleAtc = $this.data('show-multiple-atc'),
            showComingSoon = $this.data('show-comingsoon'),
            showDailyOffer = $this.data('show-dailyoffer'),
            priceCompare = $this.data('price-compare'),
            description = $this.find('.js-colour-description').html(),
            images = $this.data('images-thumb').split(';'),
            variants = $this.data('variants'),
            setProducts = $this.data('makeset'),
            hideDiscounts = $this.data('hide-discount'),
            hideFeatures = $this.data('hide-features'),
            upgradeProducts = $this.data('upgrade'),
            title = $this.data('title'),
            customLabel = $this.data('custom-label'),
            thumbnailLabel = $this.data('thumbnail-label'),
            recommendedProducts = $this.data('recomendations-url'),
            isPickAndMix = $this.data('pickmix') == true,
            variantsArray = variants.split('::'),
            multibuy = $this.data('multibuy') == true,
            has_enableKnickerMultibuy = window.themeSettings.enableKnickerMultibuy,
            pricingNode = `<div class='variant-price-wrapper'><span class='product-price heading-md'>${price}</span></div>  ${has_enableKnickerMultibuy ?` ${multibuy ? ' <div class="multi-buy-header "><h4><svg width="8" height="9" viewBox="0 0 8 9" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="4" cy="4.5" r="4" fill="currentColor"></circle></svg> Knicker Picker</h4></div>' : ''}` : ''}` ;
            if(document.querySelector('.quantity-select input')){
            document.querySelector('.quantity-select input').value=1;
            }
            // change button text
            $("#main-product button[type=submit]").html('Select size');

            //remove active state from other swatches
            $this.siblings().removeClass('current');

            // add active state to swatch
            $this.addClass('current');
            if (multibuy) {
                document.querySelector('multi-buy')?.classList.remove('is-hidden');
                document.querySelector('.pdp-2-button-container')?.classList.add('multibuy-btn');
                document.querySelector('.knicker-picker-promo')?.classList.remove('is-hidden');
            } else {
                document.querySelector('multi-buy')?.classList.add('is-hidden');
                document.querySelector('.pdp-2-button-container')?.classList.remove('multibuy-btn');
                document.querySelector('.knicker-picker-promo')?.classList.add('is-hidden');
            }

        // images
        $('.js-desktop-images-wrapper').find('img:not(.zoomImg)').each(function(index){
            var imageSrc = images[index];
            if (imageSrc) {
                $(this).attr('src', imageSrc).attr('srcset', imageSrc).removeClass('is-hidden')
            } else {
                $(this).addClass('is-hidden');
            }
        })

        $('.js-desktop-images-wrapper').find('.zoomImg').each(function(index){
            var imageSrc = images[index];
            if (imageSrc) {
                $(this).attr('src', imageSrc).attr('srcset', imageSrc).removeClass('is-hidden')
            } else {
                $(this).addClass('is-hidden');
            }
        })
        // change title
        $('.product-title-wrapper h1').html(title);

        // toggle features
        if (hideFeatures) {
            $('#productFeaturesUSP').addClass('is-hidden');
        } else {
            $('#productFeaturesUSP').removeClass('is-hidden');
        }

        // mullti items check
        var isEnabledMultiItems = $('.js-product-multiple-add').data("multiitems-available");

        if (showMultipleAtc == true) {
            isEnabledMultiItems = true;
            console.log('enabled');
        } else {
            isEnabledMultiItems = false
            console.log('disabled');
        }

        if (isEnabledMultiItems) {
            $('.js-product-multiple-add').removeClass('is-hidden');
            console.log('enabled');
        } else {
            $('.js-product-multiple-add').addClass('is-hidden');
            console.log('disaled');
        }

        // multiple items
        setMultiItemsPrices(price,priceCompare)

        // thumbnail label
        if (thumbnailLabel != '') {
            setThumbnailLabel(thumbnailLabel)
        } else {
            resetThumbnailLabel();
        }

        // Store current thumbnail label for later use
        try { window.__currentThumbnailLabel = thumbnailLabel || ''; } catch(e) {}

        // pickmix
        if (isPickAndMix) {
            $('#pickMixLabel').removeClass('is-hidden');

            // discount
            if (hideDiscounts) {
                $('#pickMixLabel').addClass('is-hidden');
            } else {
                $('#pickMixLabel').removeClass('is-hidden');
            }
        } else {
            $('#pickMixLabel').addClass('is-hidden');
        }


        // notify me
        $('.js-notify-open').addClass('is-hidden');


        if (priceCompare) {
            pricingNode = "<div class='variant-price-wrapper old-price'>" +
                "<span class='product-sale-price strikethrough'>" + priceCompare + "</span>" +
                "<span class='product-price-on-sale heading-md'>" + price + "</span>" +
                "</div>";
        }

        // active
        $this.siblings().removeClass('current');
        $this.addClass('current');

        // title
        $('.product-title-wrapper .heading-lg').html(title);
        $('.product-subtitle-wrapper .subheading-lg').html(subtitle);
        $('.js-product-breadcrumb').html(title).attr('href', href)

        // images
        $.each(images, function(index, image) {
            var newIndex = index - 2;
            $('.gallery-thumbs-swiper .swiper-wrapper').children().eq(index).find('img').attr('src', image).attr('srcset', image);
            $('#gallery-swiper .swiper-wrapper').children().eq(index).find('img').attr('src', image).attr('srcset', image);
            $('.ks-modal-image').eq(index).find('img').attr('src', image).attr('data-src', image);
        })
        $('.ks-calculator-image img, .kiwi-sizing-modal .ks-modal-image img').attr('src', images[0]);


        $('#gallery-swiper').find('.swiper-slide').each(function(index){
            var imagesLength = images.length,
                newIndex = $(this).attr("data-swiper-slide-index");

            if (!images[newIndex]) {
                newIndex = newIndex - 1;
            }

            $(this).find('img').attr('src', images[newIndex]).attr('srcset', images[newIndex]);
        })

        // description
        $('.js-accordion-description').html(description);

        // pricing
        $('.variant-prices-container').html(pricingNode);

        // variants
        var variantsNode = "";

        $.each(variantsArray, function(key,value){
            var variantData = value.split(';'),
                id = variantData[0],
                price = variantData[1],
                priceCompare = variantData[2],
                inventory = variantData[3],
                label = variantData[4],
                inventoryPolicy = variantData[5],
                productMasterId = variantData[6],
                labelNode = getSizeLabel(label,id, inventory, inventoryPolicy, hideNotify),
                inputNode = getVariantInput(id, inventory, price, inventoryPolicy, label, productMasterId, hideNotify),
                variantNode = "<div class='variant-radio-container'>" + inputNode + labelNode + "</div>";

            variantsNode = variantsNode + variantNode;

            if (inventory < 1) {
                $('.js-notify-open').removeClass('is-hidden').addClass('is-unavailable');
            }
        });
        const selected_Radio = document.querySelector('.variant-radio-container input[type="radio"]:checked')?.getAttribute('data-title');
        $('.variant-radio-wrapper').html(variantsNode);
        $('.oos-notification').attr("style", "display:none");
        $('.submit-button, .buy-now-button').attr("style", "display:block").attr('disabled', true);
        $('.submit-button-container').attr('data-active', 'false');

        // comming soon button
        if (showComingSoon) {
            $('.oos-notification').addClass('is-coming-soon').html('coming soon');
            $('.js-product-img-label').addClass('is-active').html('Coming soon');
        } else if (showDailyOffer) {
            $('.js-product-img-label').addClass('is-active').html('LIMITED TIME OFFER!');
        } else {
            $('.oos-notification').removeClass('is-coming-soon').html('sold out');
            $('.js-product-img-label').removeClass('is-active').html('');
        }

        // custom label
        if (customLabel != "") {
            $('.js-product-img-label').addClass('is-active').html(customLabel);
        } else {
            $('.js-product-img-label').removeClass('is-active').html('');
        }

        // update Yotpo dynamically
        $('.yotpo-widget-instance').attr('data-yotpo-product-id', productId);
        // window.yotpo.refreshWidgets();

        /* WORKS
        $('.submit-button').on('click', function(){
            window.qf_cart.addToCart(29155681861655, 1)
        })
        */

        initRadioEvents();

        $('.variant-radios').on('click', function(){
            var $this = $(this),
                title = $('.product-title-wrapper').text(),
                variantId = $this.attr('data-productid'),
                productId = $this.attr('data-productmasterid'),
                hideNotifyMe = $this.attr('data-hidenotify'),
                size = $this.attr('data-title'),
                stock = $this.attr('data-stock');

            $('#notifyMeVariantId').html(variantId);
            $('#notifyMeProductId').html(productId);

            if (stock == 'false') {
                $('.js-notify-open').removeClass('is-hidden is-unavailable');
            } else {
                $('.js-notify-open').addClass('is-unavailable');
            }

            if (!isEnabledMultiItems) {
                $("#main-product input[type=submit]").attr('disabled', false);
                $("#main-product .buy-now-button").attr('disabled', false);
            }

            $(".submit-button-container").attr('data-active', true);

            if (hideNotifyMe == "true") {
                $('#notifyMeModal').addClass('is-hidden');
            } else {
                $('#notifyMeModal').removeClass('is-hidden');
            }


            checkLowStock(size);
            if (multibuy) {
                const multibuyComponent = document.querySelector('multi-buy');
                const knickerQty = multibuyComponent?.getKnickerCartQty();
                multibuyComponent?.calculateProgress(knickerQty);
            }
        })

        // if (upsellType == "set") {
        fetchSetProducts(setProducts);
        fetchUpgradeProducts(upgradeProducts);
        // }

        initRecommendedProducts(recommendedProducts);

        
            var originalUrl = window.location.href;

            window.history.replaceState({}, null, href);

            var updatedUrl = href;

            // Check: only proceed if original URL already had view=review-overlays
            if (originalUrl.indexOf('view=review-overlays') !== -1) {
                // If href does NOT have view parameter, then add it
                if (href.indexOf('view=') === -1) { 
                    if (href.indexOf('?') !== -1) { 
                        updatedUrl = href + '&view=review-overlays'; 
                    } else { 
                        updatedUrl = href + '?view=review-overlays'; 
                    } 
                } else { 
                    // URL already has view parameter, keep it
                    updatedUrl = href; 
                }
            }

            // Update history
            window.history.replaceState({}, null, updatedUrl);

		// Refresh review overlays for the newly selected swatch/product
		updateReviewOverlay(updatedUrl);

        // mobile carousel scroll to initial image
        var swiper = document.querySelector('.gallery-swiper').swiper,
            mobileInitialSlide = 1,
            desktopInitialSlide = 1,
            isMobile = $(window).width() < 1000,
            swiperSlideToInitial = desktopInitialSlide;

        if (isMobile) {
            swiperSlideToInitial = mobileInitialSlide
        }

        swiper.slideTo(swiperSlideToInitial);
        const multibuyComponent = document.querySelector('multi-buy');
        if(multibuyComponent) {
            const knickerQty = multibuyComponent?.getKnickerCartQty();
            console.log('Multibuy component found', knickerQty);
            multibuyComponent?.calculateProgress(knickerQty);
        }


        // Dynamic overlay management - handles caption and review slides based on current image
        try {
            var updateOverlayContent = function() {
                // Only run on mobile devices (max-width: 769px)
                if (window.innerWidth > 769) {
                    return;
                }
                
                // Get current image index - ensure we get the most current index
                var currentIndex = 0;
                if (swiper && typeof swiper.activeIndex === 'number') {
                    currentIndex = swiper.activeIndex;
                } else {
                    // Fallback: try to get from DOM
                    var activeSlide = $('.gallery-swiper .swiper-slide-active');
                    if (activeSlide.length > 0) {
                        currentIndex = activeSlide.index();
                    }
                }
                var captionText = '';
                
                // Get thumbnail label from current swatch or stored value
                var currentThumbnailLabel = $('.js-swatch_wrapper.current').data('thumbnail-label') || '';
                if (swiper && swiper.thumbnailLabel) {
                    currentThumbnailLabel = swiper.thumbnailLabel;
                }
                if (!currentThumbnailLabel) {
                    currentThumbnailLabel = thumbnailLabel || '';
                }
                
                // Debug logging to help troubleshoot (only show once per change)
                if (console && console.log && !window.__overlayDebugShown) {
                    console.log('updateOverlayContent - currentIndex:', currentIndex, 'thumbnailLabel:', currentThumbnailLabel);
                    window.__overlayDebugShown = true;
                    setTimeout(function() { window.__overlayDebugShown = false; }, 1000);
                }
                
                // Fast caption lookup using object instead of loop
                var captionMap = {};
                if (currentThumbnailLabel) {
                    var partsList = currentThumbnailLabel.split(';');
                    for (var i = 0; i < partsList.length; i++) {
                        var item = partsList[i];
                    if (item) {
                            var parts = item.split(':');
                            if (parts.length >= 2) {
                                var text = parts[0].trim();
                                var order = parseInt(parts[1].trim(), 10);
                                captionMap[order] = text;
                            }
                        }
                    }
                }
                captionText = captionMap[currentIndex] || '';
                
                // Get overlay elements (cache for performance)
                var $overlayWrapper = $('.pdp-review-overlay-wrapper');
                var $sizeCaptionSlide = $('.size-caption-slide');
                var $sizeCaption = $('.size-caption');
                var $reviewSwiper = $('.review-overlay-swiper');
                var $reviewSlides = $('.review-overlay-swiper .swiper-slide:not(.size-caption-slide)');
                
                // Ensure caption slide exists, create if missing
                if ($sizeCaptionSlide.length === 0 && $reviewSwiper.length > 0) {
                    var captionSlideHtml = '<div class="swiper-slide size-caption-slide" style="display: none;"><div class="overlay-text glass-bg"><div class="size-caption"></div></div></div>';
                    $reviewSwiper.find('.swiper-wrapper').prepend(captionSlideHtml);
                    $sizeCaptionSlide = $('.size-caption-slide');
                    $sizeCaption = $('.size-caption');
                }
                
                // If caption slide exists but is hidden, make sure it's ready for use
                if ($sizeCaptionSlide.length > 0 && $sizeCaptionSlide.hasClass('is-hidden')) {
                    $sizeCaptionSlide.removeClass('is-hidden');
                }
                
                // Check content availability
                var hasReviews = $reviewSlides.length > 0;
                var hasCaption = captionText && captionText.trim() !== '';
                
                // Additional check: ensure we have actual content to show
                var hasActualContent = false;
                if (hasCaption) {
                    hasActualContent = true;
                }
                if (hasReviews) {
                    hasActualContent = true;
                }
                
                // Fast overlay management
                if (hasActualContent) {
                $overlayWrapper.removeClass('is-hidden').show();
                
                    // Ensure caption slide exists if we have captions
                    if (hasCaption && $sizeCaptionSlide.length === 0) {
                        window.ensureCaptionSlide();
                        $sizeCaptionSlide = $('.size-caption-slide');
                        $sizeCaption = $('.size-caption');
                    }
                    
                    // Handle caption slide
                    if ($sizeCaptionSlide.length > 0) {
                        if (hasCaption) {
                            $sizeCaption.text(captionText);
                    $sizeCaptionSlide.removeClass('is-hidden').show();
                } else {
                            // Remove caption slide completely when no caption
                            $sizeCaptionSlide.remove();
                        }
                }
                
                    // Handle review swiper
                    if (hasReviews) {
                $reviewSwiper.removeClass('is-hidden').show();
                        var overlaySwiper = $reviewSwiper[0]?.swiper;
                        if (overlaySwiper) {
                            overlaySwiper.update();
                        }
                    }
                    
                    // If only caption slide exists but it's empty, hide overlay
                    if (hasCaption && !hasReviews && (!captionText || captionText.trim() === '')) {
                        $overlayWrapper.addClass('is-hidden').hide();
                    }
                } else {
                    $overlayWrapper.addClass('is-hidden').hide();
                }
            };
            
            // Initial load - set up slide change listener and update content
            var initialThumbnailLabel = $('.js-swatch_wrapper.current').data('thumbnail-label') || $('#colourwaysList .js-swatch_wrapper').first().data('thumbnail-label') || '';
            if (console && console.log) {
                console.log('Initial load - thumbnailLabel:', initialThumbnailLabel);
            }
            if (initialThumbnailLabel) {
                // Store the initial thumbnail label
                if (swiper) {
                    swiper.thumbnailLabel = initialThumbnailLabel;
                }
                // Wait for swiper to be ready, then update overlay content
                setTimeout(function() {
                    // Update overlay content directly (updateReviewOverlay not available yet)
                    updateOverlayContent();
                    
                    // Trigger gallery-swiper slideChange event (same as variant change)
                    if (swiper && swiper.emit) {
                        if (console && console.log) {
                            console.log('Initial load - triggering gallery-swiper slideChange event');
                        }
                        swiper.emit('slideChange');
                    }
                }, 100);
            } else {
                // No thumbnail label, hide overlay
                if (console && console.log) {
                    console.log('Initial load - no thumbnail label, hiding overlay');
                }
                if (window.innerWidth <= 769) {
                    $('.pdp-review-overlay-wrapper').addClass('is-hidden').hide();
                }
            }
            
            // Make updateOverlayContent globally available
            window.updateOverlayContent = updateOverlayContent;
            
            // Debounced function for option changes
            var debounce = function(func, delay) {
                var timeoutId;
                return function() {
                    clearTimeout(timeoutId);
                    timeoutId = setTimeout(func, delay);
                };
            };
            
            // Debounced update for option changes
            window.debouncedUpdateOverlay = debounce(updateOverlayContent, 200);
            
            // Function to ensure caption slide exists for products with captions
            window.ensureCaptionSlide = function() {
                if (window.innerWidth <= 769) {
                    var $reviewSwiper = $('.review-overlay-swiper');
                    var $sizeCaptionSlide = $('.size-caption-slide');
                    
                    if ($reviewSwiper.length > 0 && $sizeCaptionSlide.length === 0) {
                        var captionSlideHtml = '<div class="swiper-slide size-caption-slide" style="display: none;"><div class="overlay-text glass-bg"><div class="size-caption"></div></div></div>';
                        $reviewSwiper.find('.swiper-wrapper').prepend(captionSlideHtml);
                    }
                }
            };
            
            // Throttle function for performance
            var throttle = function(func, delay) {
                var timeoutId;
                var lastExecTime = 0;
                return function() {
                    var currentTime = Date.now();
                    if (currentTime - lastExecTime > delay) {
                        func.apply(this, arguments);
                        lastExecTime = currentTime;
                    } else {
                        clearTimeout(timeoutId);
                        timeoutId = setTimeout(function() {
                            func.apply(this, arguments);
                            lastExecTime = Date.now();
                        }, delay - (currentTime - lastExecTime));
                    }
                };
            };
            
            // Throttled update function
            var throttledUpdate = throttle(updateOverlayContent, 100);
            
            // Add event listener for gallery swiper slide changes
            if (swiper && swiper.on) {
                swiper.on('slideChange', function() {
                    // Small delay to ensure swiper has fully updated
                    setTimeout(function() {
                        // Update thumbnail label for current swatch
                        var currentThumbnailLabel = $('.js-swatch_wrapper.current').data('thumbnail-label') || '';
                        if (currentThumbnailLabel) {
                            thumbnailLabel = currentThumbnailLabel;
                            // Store in swiper for consistency
                            swiper.thumbnailLabel = currentThumbnailLabel;
                        }
                        throttledUpdate();
                    }, 50);
                });
            }
            
            // Ensure slide change listener is set up on initial load
            setTimeout(function() {
                var swiperEl = document.querySelector('.gallery-swiper');
                if (swiperEl && swiperEl.swiper && swiperEl.swiper.on && !swiperEl.swiper.__initialSlideListenerSet) {
                    swiperEl.swiper.on('slideChange', function() {
                        if (window.innerWidth <= 769) {
                            setTimeout(function() {
                                var currentThumbnailLabel = $('.js-swatch_wrapper.current').data('thumbnail-label') || '';
                                if (currentThumbnailLabel) {
                                    swiperEl.swiper.thumbnailLabel = currentThumbnailLabel;
                                }
                                if (window.updateOverlayContent) {
                                    window.updateOverlayContent();
                                }
                            }, 50);
                        }
                    });
                    swiperEl.swiper.__initialSlideListenerSet = true;
                }
            }, 200);
            
            // Add window resize listener to handle responsive behavior
            $(window).on('resize', throttle(updateOverlayContent, 150));
            
            // Add listeners for option changes
            $(document).on('change', '.variant-radios, .js-swatch_wrapper', function() {
                if (window.innerWidth <= 769) {
                    window.debouncedUpdateOverlay();
                }
            });
            
            // Add listener for swatch changes
            $(document).on('click', '.js-swatch_wrapper', function() {
                if (window.innerWidth <= 769) {
                    setTimeout(function() {
                        window.ensureCaptionSlide();
                        window.updateOverlayContent();
                    }, 50);
                }
            });
        } catch(e) {
            if (console && console.warn) { console.warn('size-caption sync error', e); }
        }
         // On color/print change button issue
        if (selected_Radio) {
            document.querySelector(`.variant-radio-container input[data-title="${selected_Radio}"]`)?.click();
        }
    })
    $('.variant-radios').on('click', function(){
        var $this = $(this),
            variantId = $this.attr('data-variant-id'),
            hideNotifyMe = $this.attr('data-hidenotify'),
            title = $this.attr('data-title'),
            stock = $this.attr('data-stock');

        $('#notifyMeVariantId').html(variantId);

        if (stock == 'false') {
            $('.js-notify-open').removeClass('is-hidden is-unavailable');
        } else {
            $('.js-notify-open').addClass('is-unavailable');
        }

        if (hideNotifyMe == "true") {
            $('#notifyMeModal').addClass('is-hidden');
        } else {
            $('#notifyMeModal').removeClass('is-hidden');
        }

        checkLowStock(title);
    });
}

function initMakeASet() {
    var products = $('.js-swatch_wrapper.current').data('makeset'),
        upgradeProducts = $('.js-swatch_wrapper.current').data('upgrade');

    fetchSetProducts(products);
    fetchUpgradeProducts(upgradeProducts);
}

function getSetProducts() {

}

function sortSetProducts(productsListOld, productsListNew) {
    var sortedProductsList = [];

    $.each(productsListOld, function(index, productHandle) {
        var productHandleOld = productHandle.split('/products/')[1],
            productsHandleOld2 = productHandleOld.split('?')[0];

        $.each(productsListNew, function(index2, productObj) {
            var productObjHandle = productObj.url.split('/products/')[1];

            if (productObjHandle == productsHandleOld2) {
                sortedProductsList.push(productObj);
            }
        });

    })

    return sortedProductsList;
}

function fetchUpgradeProducts(products) {
    if (products) {
        var productsList = products.split(';'),
            requestAmount = 0,
            productsArray = [];

        $('#upgradeSetWrapper').removeClass('is-hidden');

        $.each(productsList, function( index, productUrl ) {
            axios.get(productUrl)
                .then(function (response) {
                    // Success
                    productsArray.push(response.data);
                    requestAmount++;

                    if (requestAmount == productsList.length) {
                        var newProductsArray = sortSetProducts(productsList, productsArray);

                        if (newProductsArray) {
                            initUpgradeProducts(newProductsArray);
                            // $('.freq-product-variants-initial').on('click', function(){
                            //     $(this).parent().toggleClass('is-expanded');
                            // })

                            // $('.freq-variant-radio-container').on('click', function(){
                            //     var $parent = $(this).parent(),
                            //         newLabel = $(this).find('label').text();

                            //     $parent.find('.freq-product-variants-initial').html(newLabel);
                            //     $(this).parent().removeClass('is-expanded').addClass('is-selected');
                            // })

                        }

                    }
                })
        });
    } else {
        $('#upgradeSetWrapper').addClass('is-hidden');
    }
}

function initUpgradeProducts(setProducts) {
    var t = document.getElementById("main-product-container"),
        showAllProducts = $('#makeSetWrapper').data('showall');

    if (t) {
        var n = t.getAttribute("data-prod-id");
        window.log("MAIN PROD ID", n);

        var n = setProducts;
        if (setProducts) {
            n = setProducts;
        }

        var a = document.querySelector(".upgrade-desktop"),
            i = document.querySelector(".upgrade-mobile");
        window.log(">>>>>> FREQ PRODUCTS", n);
        a.innerHTML = "";
        i.innerHTML = "";
        for (var d = 0; d < n.length; d++) {
            //var e = n[d].price / 100, r = n[d].compare_at_price;
            var e = n[d].price.replace('.00',''), r = n[d].compare_at_price;
            var priceOrigin = parseInt(e.replace(/[^0-9]/gi, ''));
            var priceCompare = parseInt(r);
            var additionalClass = ''

            if (Shopify.currency.active !== "USD" && Shopify.currency.active !== "GBP") {
                //e = n[d].price_origin
            }

            if (priceCompare != 0 && priceOrigin != priceCompare) {
                additionalClass = 'is-sale-product'
            }


            null == r || 0 == r ? r = "" : (r /= 100, r = "<span class='strikethrough' style='margin-right:5px' id='compare-price-".concat(n[d].id, "'>£").concat(r.toFixed(2), "</span>"));
            var c = n[d].id, o = n[d].variants;
            freq_v2 = [];
            freq_v = [];
            for (var s = 0; s < o.length; s++) 1 == o[s].available && (freq_v += '\n                        <div class="freq-variant-radio-container">\n                            <input class="freq-variant-radios" type="radio" data-prod-id="'.concat(c, '" id="v-radio-').concat(o[s].id, '" name="id-').concat(c, '" value="').concat(o[s].id, '">\n                            <label for="v-radio-').concat(o[s].id, '">\n                                ').concat(o[s].title, "\n                            </label>\n                        </div>\n                        "));
            // for (var x = 0; x < o.length; x++) 1 == o[x].available && (freq_v2 += '\n                        <div class="freq-variant-radio-container">\n                            <input class="freq-variant-radios" type="radio" data-prod-id="'.concat(c, '" id="v-radio-').concat(o[x].id, '" name="id-').concat(c, '" value="').concat(o[x].id, '">\n                            <label for="v-radio-').concat(o[s].id, '">\n                                ').concat(o[s].title, "\n                            </label>\n                        </div>\n                        "));
            // for (var x = 0; x < o.length; x++) 1 == o[x].available && (freq_v2 += '\n                        <option value="').concat(o[x].id, '" >\n    ').concat(o[x].title, "\n    </option>\n                        "));

            n[d].tags.includes("Subscription") ? (window.log("HAS SUBSCRIPTION TAG", n[d].tags), a.innerHTML += '\n         <div class="swiper-slide">\n             <div class="freq-product-card makeset-product-card">\n              <div class="button-wishlist"><button data-product="'.concat(n[d].id, '" data-variant="').concat(n[d].variants[0].id, '"></button></div>\n  <div class="makeset-label 1').concat(additionalClass, '">save 30%</div>\n                   <a href="').concat(n[d].url, '" class="freq-product-img">\n                            <img src="').concat(n[d].featured_image, '" alt="" />\n                        </a>\n                        <div class="freq-product-info">\n                            <div class="freq-product-title">\n                            <a href="').concat(n[d].url, '">').concat(n[d].title, '</a>\n                            </div>\n                            <div class="freq-product-price">\n                                <div>').concat(r, '<span class="product-price f-b-price">').concat(e, '</span></div>\n                            </div>\n                        </div>\n                        <div class="1 freq-product-button">\n                            <a class="button-2" href="').concat(n[d].url, '">view</a>\n                        </div>\n                    </div>\n                '), i.innerHTML += '\n                    <div class="swiper-slide">\n                        <div class="freq-product-card makeset-product-card">\n                        <div class="button-wishlist"><button data-product="'.concat(n[d].id, '" data-variant="').concat(n[d].variants[0].id, '"></button></div>\n         <div class="makeset-label 2').concat(additionalClass, '">Save 30%</div>\n                   <a href="').concat(n[d].url, '" class="freq-product-img">\n                            <img src="').concat(n[d].featured_image, '" alt="" />\n                            </a>\n                            <div class="freq-product-info">\n                                <div class="freq-product-title">\n                                    ').concat(n[d].title, '\n                                </div>\n                                <div class="freq-product-price">\n                                    <div>').concat(r, '<span class="product-price f-b-price">').concat(e, '</span></div>\n                                </div>\n                            </div>\n                            <div class="2 freq-product-button">\n                                <a class="button-2" href="').concat(n[d].url, '">view</a>\n                            </div>\n                        </div>\n                    </div>\n                ')) : (window.log("HAS NOT GOT SUBSCRIPTION TAG", n[d].tags), a.innerHTML += '\n        <div class="swiper-slide">\n              <div class="freq-product-card makeset-product-card">\n                    <div class="button-wishlist"><button data-product="'.concat(n[d].id, '" data-variant="').concat(n[d].variants[0].id, '"></button></div>\n       <div class="makeset-label is-hidden 3').concat(additionalClass, '">Save 30%</div>\n                 <a href="').concat(n[d].url, '" class="freq-product-img">\n                            <img src="').concat(n[d].featured_image, '" alt="" />\n                        </a>\n                        <div class="freq-product-info">\n                            <div class="freq-product-title">\n                            <a href="').concat(n[d].url, '">').concat(n[d].title, '</a>\n      <div class="makeset-label 4').concat(additionalClass, '">Save 30%</div>\n                       </div>\n                            <div class="freq-product-price">\n                                <div>').concat(r, '<span class="product-price f-b-price">').concat(e, '</span></div>\n                            </div>\n       <div class="freq-product-variants-wrapper">\n        <div class="freq-product-variants"><div class="freq-product-variants-initial">Size <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 26" width="12.5" height="25"><path d="M2 24.656c-.078 0-.156-.016-.234-.047s-.133-.066-.187-.129c-.117-.117-.176-.258-.176-.422s.059-.305.176-.422l10.371-10.371L1.578 2.883c-.117-.117-.176-.258-.176-.422s.059-.305.176-.422.258-.176.422-.176.305.059.422.176l10.805 10.793a.59.59 0 0 1 .176.434c0 .172-.059.305-.176.422L2.422 24.48a.42.42 0 0 1-.199.129.54.54 0 0 1-.223.047zm0 0" fill="#0f0f0f"></path></svg></div>\n                                ').concat(freq_v, '\n                            </div>\n </div>\n          <div class="3 freq-product-button">\n                            <button class="button button-2" id="').concat(c, '" data-variant-id="">add to basket</button>\n                   </div>\n         </div>\n                    </div>\n                '), i.innerHTML += '\n                    <div class="swiper-slide">\n                        <div class="freq-product-card">\n                        <div class="button-wishlist"><button data-product="'.concat(n[d].id, '" data-variant="').concat(n[d].variants[0].id, '"></button></div>\n                    <a href="').concat(n[d].url, '" class="freq-product-img">\n                             <img src="').concat(n[d].featured_image, '" alt="" />\n                            </a>\n                            <div class="freq-product-info">\n                                <div class="freq-product-title">\n                                   <a href="').concat(n[d].url, '">').concat(n[d].title, '</a>\n                              </div>\n           <div class="makeset-label 5').concat(additionalClass, '">Save 30%</div>\n                            <div class="freq-product-price">\n                                    <div>').concat(r, '<span class="product-price f-b-price">').concat(e, '</span></div>\n                                </div>\n               <div class="freq-product-variants-wrapper">\n                <div class="freq-product-variants"><div class="freq-product-variants-initial">Size <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 26" width="12.5" height="25"><path d="M2 24.656c-.078 0-.156-.016-.234-.047s-.133-.066-.187-.129c-.117-.117-.176-.258-.176-.422s.059-.305.176-.422l10.371-10.371L1.578 2.883c-.117-.117-.176-.258-.176-.422s.059-.305.176-.422.258-.176.422-.176.305.059.422.176l10.805 10.793a.59.59 0 0 1 .176.434c0 .172-.059.305-.176.422L2.422 24.48a.42.42 0 0 1-.199.129.54.54 0 0 1-.223.047zm0 0" fill="#0f0f0f"></path></svg></div>\n \n                                    ').concat(freq_v, '\n                                </div>\n  </div>\n            <div class="4 freq-product-button">\n                                <button id="mob-').concat(c, '" data-variant-id="">add to basket</button>\n                            </div>\n                  </div>\n                                                 </div>\n                    </div>\n                '))

        }
        for (var l = document.querySelectorAll(".freq-desktop .freq-variant-radios"), v = function (t) {
            l[t].addEventListener("click", (function () {
                var n = l[t].value, a = l[t].getAttribute("data-prod-id");
                window.log("PRODUCT ID", a), document.getElementById(a).setAttribute("data-variant-id", n), document.getElementById(a).innerHTML = "add to basket"
            }))
        }, u = 0; u < l.length; u++) v(u);
        for (var p = document.querySelectorAll(".freq-desktop .freq-product-button button"), f = 0; f < p.length; f++) p[f].addEventListener("click", (function () {
            window.log("CLICKED", this.getAttribute("data-variant-id")), var_id = this.getAttribute("data-variant-id"), var_id ? window.qf_cart.addToCart(var_id, 1) : this.innerHTML = "please select a size"
        }));
        for (var b = document.querySelectorAll(".freq-swiper .freq-variant-radios"), q = function (t) {
            b[t].addEventListener("click", (function () {
                var n = l[t].value, a = l[t].getAttribute("data-prod-id");
                window.log("VARIANT ID", a), window.log("BUTTON", document.getElementById(a)), document.getElementById("mob-" + a).setAttribute("data-variant-id", n), document.getElementById("mob-" + a).innerHTML = "add to basket"
            }))
        }, g = 0; g < b.length; g++) q(g);
        for (var w = document.querySelectorAll(".freq-swiper .freq-product-button button"), m = 0; m < w.length; m++) w[m].addEventListener("click", (function () {
            window.log("CLICKED", this.getAttribute("data-variant-id")), var_id_mobile = this.getAttribute("data-variant-id"), var_id_mobile ? window.qf_cart.addToCart(var_id_mobile, 1) : this.innerHTML = "please select a size"
        }))
    }
}

function fetchSetProducts(products) {
    var $setWrapper = $('#makeSetWrapper');

    if (products) {
        var productsList = products.split(';'),
            requestAmount = 0,
            productsArray = [];

        $.each(productsList, function( index, productUrl ) {
            console.log(productUrl);

            axios.get(productUrl)
                .then(function (response) {
                    // Success
                    productsArray.push(response.data);
                    requestAmount++;

                    if (requestAmount == productsList.length) {
                        var newProductsArray = sortSetProducts(productsList, productsArray);

                        if (newProductsArray) {
                            initSetProducts(newProductsArray);

                            setTimeout(function () {
                                $('.freq-product-variants-initial').on('click', function(){
                                    $(this).parent().toggleClass('is-expanded');
                                })

                                $('.freq-variant-radio-container').on('click', function(){
                                    var $parent = $(this).parent(),
                                        newLabel = $(this).find('label').text();

                                    $parent.find('.freq-product-variants-initial').html(newLabel);
                                    $(this).parent().removeClass('is-expanded').addClass('is-selected');
                                })

                                // Toggle save label for discounted products
                                $('.makeset-product-card').each(function(){
                                    var $this = $(this),
                                        $price = $this.find('.freq-product-price'),
                                        $saleLabel = $this.find('.makeset-label'),
                                        isSalePrice = $price.find('.strikethrough');

                                    if (isSalePrice.length > 0) {
                                        $saleLabel.addClass('label-hidden')
                                    } else {
                                        $saleLabel.removeClass('label-hidden')
                                    }
                                })

                                var mainProductSalePrice = $('#main-product').find('.product-sale-price');

                                if (mainProductSalePrice.length > 0) {
                                    $('.makeset-product-card').each(function(){
                                        $(this).find('.makeset-label').addClass('label-hidden')
                                    })
                                } else {
                                    $('.makeset-product-card').each(function(){
                                        $(this).find('.makeset-label').removeClass('label-hidden')
                                    })
                                }
                                // END Toggle save label for discounted products

                                initSetProductsCarousel();
                            }, 500);
                        }

                        initSetCountry();
                    }
                })
        });

        $setWrapper.removeClass('is-hidden');
    } else {
        var productContainer = document.getElementById("main-product-container");
        if (!productContainer) {
            $setWrapper.addClass('is-hidden');
            return;
        }
        var productId = productContainer.getAttribute("data-prod-id");

        axios.get(window.Shopify.routes.root + 'recommendations/products.json?product_id=' + productId + '&limit=4')
            .then(function(recResponse) {
                var recommended = recResponse.data.products;
                if (!recommended || recommended.length === 0) {
                    $setWrapper.addClass('is-hidden');
                    return;
                }

                var recProductsList = recommended.map(function(p) {
                    return window.Shopify.routes.root + 'products/' + p.handle + '?view=makeset';
                });
                var recRequestAmount = 0,
                    recProductsArray = [];

                $.each(recProductsList, function(index, productUrl) {
                    axios.get(productUrl).then(function(response) {
                        recProductsArray.push(response.data);
                        recRequestAmount++;

                        if (recRequestAmount === recProductsList.length) {
                            var newProductsArray = sortSetProducts(recProductsList, recProductsArray);

                            if (newProductsArray) {
                                initSetProducts(newProductsArray);

                                setTimeout(function() {
                                    $('.freq-product-variants-initial').on('click', function(){
                                        $(this).parent().toggleClass('is-expanded');
                                    });
                                    $('.freq-variant-radio-container').on('click', function(){
                                        var $parent = $(this).parent(),
                                            newLabel = $(this).find('label').text();
                                        $parent.find('.freq-product-variants-initial').html(newLabel);
                                        $(this).parent().removeClass('is-expanded').addClass('is-selected');
                                    });
                                    $('.makeset-product-card').each(function(){
                                        var $this = $(this),
                                            $price = $this.find('.freq-product-price'),
                                            $saleLabel = $this.find('.makeset-label'),
                                            isSalePrice = $price.find('.strikethrough');
                                        if (isSalePrice.length > 0) {
                                            $saleLabel.addClass('label-hidden');
                                        } else {
                                            $saleLabel.removeClass('label-hidden');
                                        }
                                    });
                                    var mainProductSalePrice = $('#main-product').find('.product-sale-price');
                                    if (mainProductSalePrice.length > 0) {
                                        $('.makeset-product-card').each(function(){
                                            $(this).find('.makeset-label').addClass('label-hidden');
                                        });
                                    } else {
                                        $('.makeset-product-card').each(function(){
                                            $(this).find('.makeset-label').removeClass('label-hidden');
                                        });
                                    }

                                    initSetProductsCarousel();
                                }, 500);
                            }

                            initSetCountry();
                        }
                    });
                });

                $setWrapper.removeClass('is-hidden');
            })
            .catch(function() {
                $setWrapper.addClass('is-hidden');
            });
    }
}

function initSetProducts(setProducts) {
    var t = document.getElementById("main-product-container"),
        productType = $('.product-title-wrapper h1').text().toLowerCase(),
        showDiscountedPrice = $('#makeSetWrapper').data('show-discounted'),
        showAllProducts = $('#makeSetWrapper').data('showall');

    if (t) {
        var n = t.getAttribute("data-prod-id");
        window.log("MAIN PROD ID", n);

        var n = setProducts;
        if (setProducts) {
            n = setProducts;
        }

        var a = document.querySelector(".frequently-bought-desktop"),
            i = document.querySelector(".frequently-bought");
        var isOldDesign = $('#makeSetWrapper').data('old-design');
        var listContainer = document.querySelector('.makeset-list');
        window.log(">>>>>> FREQ PRODUCTS", n);
        a.innerHTML = "";
        i.innerHTML = "";
        if (isOldDesign && listContainer) listContainer.innerHTML = "";
        for (var d = 0; d < n.length; d++) {
            //var e = n[d].price / 100, r = n[d].compare_at_price;
            var e = n[d].price.replace('.00',''),
                r = n[d].compare_at_price;

            // if (showDiscountedPrice == false) {
            e = n[d].priceOrigin.replace('.00','');
            // }

            var priceOrigin = parseInt(e.replace(/[^0-9]/gi, ''));
            var priceCompare = parseInt(r);

            if (Shopify.currency.active !== "USD" && Shopify.currency.active !== "GBP") {
                //e = n[d].price_origin
            }

            if (priceOrigin != priceCompare) {
                //e = n[d].price_origin
            }

            if (productType == "lace cami" || productType == "sculpt cami" || productType == "square lace cami") {
                n[d].setDiscount = ""
            }

            // if (showAllProducts == "true" || ( showAllProducts == false && (priceCompare == 0 || priceCompare == priceOrigin))) {
            null == r || 0 == r ? r = "" : (r /= 100, r = "<span class='strikethrough' style='margin-right:5px' id='compare-price-".concat(n[d].id, "'>£").concat(r.toFixed(2).replace('.00',''), "</span>"));
            var c = n[d].id, o = n[d].variants;
            freq_v2 = [];
            freq_v = [];
            for (var s = 0; s < o.length; s++) 1 == o[s].available && (freq_v += '\n                        <div class="freq-variant-radio-container">\n                            <input class="freq-variant-radios" type="radio" data-prod-id="'.concat(c, '" id="v-radio-').concat(o[s].id, '" name="id-').concat(c, '" value="').concat(o[s].id, '">\n                            <label for="v-radio-').concat(o[s].id, '">\n                                ').concat(o[s].title, "\n                            </label>\n                        </div>\n                        "));
            // for (var x = 0; x < o.length; x++) 1 == o[x].available && (freq_v2 += '\n                        <div class="freq-variant-radio-container">\n                            <input class="freq-variant-radios" type="radio" data-prod-id="'.concat(c, '" id="v-radio-').concat(o[x].id, '" name="id-').concat(c, '" value="').concat(o[x].id, '">\n                            <label for="v-radio-').concat(o[s].id, '">\n                                ').concat(o[s].title, "\n                            </label>\n                        </div>\n                        "));
            // for (var x = 0; x < o.length; x++) 1 == o[x].available && (freq_v2 += '\n                        <option value="').concat(o[x].id, '" >\n    ').concat(o[x].title, "\n    </option>\n                        "));

            (function() {
                var chevronSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none"><path d="M1 1L6 6L11 1" stroke="#6B6966" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
                var productColor = n[d].color ? '<div class="freq-product-color">' + n[d].color + '</div>' : '';
                var oldDesignTitle = n[d].color ? n[d].title + ' - ' + n[d].color : n[d].title;
                if (isOldDesign && listContainer) {
                    if (n[d].tags.includes('Subscription')) {
                        listContainer.innerHTML += '<div class="makeset-list-item"><a href="' + n[d].url + '" class="makeset-list-image"><img src="' + n[d].featured_image + '" alt="" /></a><div class="makeset-list-info"><div class="makeset-list-title-price"><div class="freq-product-title"><a href="' + n[d].url + '">' + oldDesignTitle + '</a></div><div class="makeset-list-price product-price">' + e + '</div></div><div class="makeset-list-button"><a class="button button-2" href="' + n[d].url + '">View</a></div></div></div>';
                    } else {
                        listContainer.innerHTML += '<div class="makeset-list-item"><a href="' + n[d].url + '" class="makeset-list-image"><img src="' + n[d].featured_image + '" alt="" /></a><div class="makeset-list-info"><div class="makeset-list-title-price"><div class="freq-product-title"><a href="' + n[d].url + '">' + oldDesignTitle + '</a></div><div class="makeset-list-price product-price">' + e + '</div></div><div class="freq-product-variants-wrapper"><div class="freq-product-variants"><div class="freq-product-variants-initial">Size ' + chevronSvg + '</div>' + freq_v + '</div></div><div class="makeset-list-button"><button class="button button-2 makeset-list-add" id="list-' + c + '" data-variant-id="">Add To Basket</button></div></div></div>';
                    }
                } else if (n[d].tags.includes("Subscription")) {
                    window.log("HAS SUBSCRIPTION TAG", n[d].tags);
                    var card = '<div class="swiper-slide"><div class="freq-product-card makeset-product-card"><a href="' + n[d].url + '" class="freq-product-img"><img src="' + n[d].featured_image + '" alt="" /></a><div class="freq-product-info"><div class="freq-product-title"><a href="' + n[d].url + '">' + n[d].title + '</a></div>' + productColor + '<div class="freq-product-price"><div><span class="product-price f-b-price">' + e + '</span>' + r + '</div></div></div><div class="freq-product-button"><a class="button-2" href="' + n[d].url + '">View</a></div></div></div>';
                    a.innerHTML += card;
                    i.innerHTML += card;
                } else {
                    window.log("HAS NOT GOT SUBSCRIPTION TAG", n[d].tags);
                    a.innerHTML += '<div class="swiper-slide"><div class="freq-product-card makeset-product-card"><a href="' + n[d].url + '" class="freq-product-img"><img src="' + n[d].featured_image + '" alt="" /></a><div class="freq-product-info"><div class="freq-product-title"><a href="' + n[d].url + '">' + n[d].title + '</a></div>' + productColor + '<div class="freq-product-price"><div><span class="product-price f-b-price">' + e + '</span>' + r + '</div></div><div class="freq-product-variants-wrapper"><div class="freq-product-variants"><div class="freq-product-variants-initial">Size ' + chevronSvg + '</div>' + freq_v + '</div></div></div><div class="freq-product-button"><button class="button button-2" id="' + c + '" data-variant-id="">Add To Basket</button></div></div></div>';
                    i.innerHTML += '<div class="swiper-slide"><div class="freq-product-card makeset-product-card"><a href="' + n[d].url + '" class="freq-product-img"><img src="' + n[d].featured_image + '" alt="" /></a><div class="freq-product-info"><div class="freq-product-title"><a href="' + n[d].url + '">' + n[d].title + '</a></div>' + productColor + '<div class="freq-product-price"><div><span class="product-price f-b-price">' + e + '</span>' + r + '</div></div><div class="freq-product-variants-wrapper"><div class="freq-product-variants"><div class="freq-product-variants-initial">Size ' + chevronSvg + '</div>' + freq_v + '</div></div></div><div class="freq-product-button"><button class="button button-2" id="mob-' + c + '" data-variant-id="">Add To Basket</button></div></div></div>';
                }
            })()
            // }
        }
        for (var l = document.querySelectorAll(".freq-desktop .freq-variant-radios"), v = function (t) {
            l[t].addEventListener("click", (function () {
                var n = l[t].value, a = l[t].getAttribute("data-prod-id");
                window.log("PRODUCT ID", a), document.getElementById(a).setAttribute("data-variant-id", n), document.getElementById(a).innerHTML = "add to basket"
            }))
        }, u = 0; u < l.length; u++) v(u);
        for (var p = document.querySelectorAll(".freq-desktop .freq-product-button button"), f = 0; f < p.length; f++) p[f].addEventListener("click", (function () {
            window.log("CLICKED", this.getAttribute("data-variant-id")), var_id = this.getAttribute("data-variant-id"), var_id ? window.qf_cart.addToCart(var_id, 1) : this.innerHTML = "please select a size"
        }));
        for (var b = document.querySelectorAll(".freq-swiper .freq-variant-radios"), q = function (t) {
            b[t].addEventListener("click", (function () {
                var n = l[t].value, a = l[t].getAttribute("data-prod-id");
                window.log("VARIANT ID", a), window.log("BUTTON", document.getElementById(a)), document.getElementById("mob-" + a).setAttribute("data-variant-id", n), document.getElementById("mob-" + a).innerHTML = "add to basket"
            }))
        }, g = 0; g < b.length; g++) q(g);
        for (var w = document.querySelectorAll(".freq-swiper .freq-product-button button"), m = 0; m < w.length; m++) w[m].addEventListener("click", (function () {
            window.log("CLICKED", this.getAttribute("data-variant-id")), var_id_mobile = this.getAttribute("data-variant-id"), var_id_mobile ? window.qf_cart.addToCart(var_id_mobile, 1) : this.innerHTML = "please select a size"
        }))

        if (isOldDesign && listContainer) {
            listContainer.querySelectorAll('.freq-variant-radio-container').forEach(function(container) {
                container.addEventListener('click', function() {
                    var radio = this.querySelector('input[type="radio"]');
                    var prodId = radio ? radio.getAttribute('data-prod-id') : null;
                    var varId = radio ? radio.value : null;
                    if (prodId && varId) {
                        var btn = document.getElementById('list-' + prodId);
                        if (btn) {
                            btn.setAttribute('data-variant-id', varId);
                            btn.textContent = 'Add To Basket';
                        }
                    }
                });
            });
            listContainer.querySelectorAll('.makeset-list-add').forEach(function(btn) {
                btn.addEventListener('click', function() {
                    var varId = this.getAttribute('data-variant-id');
                    if (varId) {
                        window.qf_cart.addToCart(varId, 1);
                    } else {
                        this.textContent = 'please select a size';
                    }
                });
            });
        }
    }
}

function initSetProductsCarousel() {
    if ($('#makeSetWrapper').data('old-design')) return;
    if (document.querySelector('.freq-desktop .swiper-slide')) {
        new window.swiper('.freq-desktop', {
            slidesPerView: 2,
            spaceBetween: 16,
            loop: false,
            navigation: {
                nextEl: '.makeset-next',
                prevEl: '.makeset-prev',
            }
        });
    }
    if (document.querySelector('.freq-swiper .swiper-slide')) {
        new window.swiper('.freq-swiper', {
            slidesPerView: 1.6,
            spaceBetween: 16,
            loop: false,
        });
    }
}

function initSetCountry() {
    if (Shopify.currency.active !== "USD" && Shopify.currency.active !== "GBP") {
        var el = document.getElementById("makeSetWrapper");
        el.className += " is-other-countries";
    }
}

function initNotifyMeEvents() {
    $('#notifyMeEmail').on('keyup', function(){
        var length = $(this).val().length,
            $submit = $('#notifyMeSubmit');

        if (length > 0) {
            $submit.removeClass('is-hidden')
        } else {
            $submit.addClass('is-hidden');
        }
    })
    $('#notifyMeSubmit').on('click', function(){
        var klaviyoId = 'KvG7FF',
            email = $('#notifyMeEmail').val(),
            productId = $('#notifyMeProductId').html(),
            variantIdParam = "$shopify:::$default:::" + $('#notifyMeVariantId').html();

        var payload = {
            "data": {
                "type": "back-in-stock-subscription",
                "attributes": {
                    "profile": {
                        "data": {
                            "type": "profile",
                            "attributes": {
                                "email": email,
                            }
                        }
                    },
                    "channels": ["EMAIL"],
                },
                "relationships": {
                    "variant": {
                        "data": {
                            "type": "catalog-variant",
                            "id": variantIdParam
                        }
                    }
                }
            }
        }

        $.ajax({
            url: 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + klaviyoId,
            type: 'post',
            // data: submitData,
            headers: {
                "Content-Type": "application/json",
                "revision":"2024-06-15"
            },
            // body: JSON.stringify(payload),
            data: JSON.stringify(payload),
            beforeSend: function() {
                $('#notifyMeSubmit').addClass('is-loading');
            },
            success: function (response) {
                $('#notifyMeBody').addClass("is-hidden");
                $('#notifyMeSubmit').addClass('is-hidden');
                $('#notifyMeSuccess').removeClass("is-hidden");
                console.log(response, " success")
            }
        });
    })
}

function setFlagPosition() {
    $('.ge-country-switcher-container').appendTo('.tooltipFlag ul li:last-child').addClass('is-visible');
}

function setFlagEvents() {
    var $flagSelector = $('#flagSelector');

    if (!$flagSelector.hasClass('is-events-added')) {
        $flagSelector.one('click', '.disclosure__button', function() {
            console.log('clicked');
            var $this = $(this).parent();
            if ($this.hasClass('is-open')){
                $this.removeClass('is-open');
                $('.location-submenu').removeClass('is-open');
            } else {
                $this.addClass('is-open');
                $('.location-submenu').addClass('is-open');
            }

            $flagSelector.addClass('is-events-added');
        })
    }
}

function updateDynamicMakeSetUrl() {
    // set active filters params
    var initialUrl = location.protocol + '//' + location.host + location.pathname,
        activeColourFilters = [],
        activeTopTypeFilter = [],
        activeTopSizeFilter = [],
        activeBottomSizeFilter = [],
        activeBottomTypeFilter = [],
        filterColoursUrl = "",
        filterTopTypeUrl = "",
        filterBottomTypeUrl = "",
        filterTopSizeUrl = "",
        filterBottomSizeUrl = "";

    // getting active colour filters
    $('.js-set-filter-colour').each(function(){
        var $colour = $(this);

        if ($colour.hasClass('is-active')) {
            activeColourFilters.push($colour.attr('data-colour'))
        }
    })

    if (activeColourFilters.length > 0) {
        filterColoursUrl = '&colour='
        $.each(activeColourFilters, function(index, item){
            filterColoursUrl = filterColoursUrl + item + "+";
        })
        filterColoursUrl = filterColoursUrl.slice(0,-1);
    }

    // getting active top type filters
    $('.js-set-filter-type-top').each(function(){
        var $filter = $(this);

        if ($filter.hasClass('is-active')) {
            activeTopTypeFilter.push($filter.attr('data-type'))
        }
    })

    if (activeTopTypeFilter.length > 0) {
        filterTopTypeUrl = '&toptype='
        $.each(activeTopTypeFilter, function(index, item){
            filterTopTypeUrl = filterTopTypeUrl + item + "+";
        })
        filterTopTypeUrl = filterTopTypeUrl.slice(0,-1);
    }

    // getting active top size filters
    $('.js-set-filter-size-top').each(function(){
        var $filter = $(this);

        if ($filter.hasClass('is-active')) {
            activeTopSizeFilter.push($filter.attr('data-size'))
        }
    })

    if (activeTopSizeFilter.length > 0) {
        filterTopSizeUrl = '&topsize='
        $.each(activeTopSizeFilter, function(index, item){
            filterTopSizeUrl = filterTopSizeUrl + item + "+";
        })
        filterTopSizeUrl = filterTopSizeUrl.slice(0,-1);
    }

    // getting active size bottom filters
    $('.js-set-filter-size-bottom').each(function(){
        var $filter = $(this);

        if ($filter.hasClass('is-active')) {
            activeBottomSizeFilter.push($filter.attr('data-size'))
        }
    })

    if (activeBottomSizeFilter.length > 0) {
        filterBottomSizeUrl = '&bottomsize='
        $.each(activeBottomSizeFilter, function(index, item){
            filterBottomSizeUrl = filterBottomSizeUrl + item + "+";
        })
        filterBottomSizeUrl = filterBottomSizeUrl.slice(0,-1);
    }

    // getting active type bottom filters
    $('.js-set-filter-type').each(function(){
        var $filter = $(this);

        if ($filter.hasClass('is-active')) {
            activeBottomTypeFilter.push($filter.attr('data-type'))
        }
    })

    if (activeBottomTypeFilter.length > 0) {
        filterBottomTypeUrl = '&bottomtype='
        $.each(activeBottomTypeFilter, function(index, item){
            filterBottomTypeUrl = filterBottomTypeUrl + item + "+";
        })
        filterBottomTypeUrl = filterBottomTypeUrl.slice(0,-1);
    }

    var finalUrl = initialUrl + '?' + filterColoursUrl + filterTopTypeUrl + filterTopSizeUrl + filterBottomSizeUrl + filterBottomTypeUrl;

    window.history.replaceState({}, null, finalUrl);

}

function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
}

function initMakeSetUrls() {
    var url = window.location.href,
        colourParams = getUrlParameter("colour"),
        topTypeParams = getUrlParameter("toptype"),
        topSizeParams = getUrlParameter("topsize"),
        bottomTypeParams = getUrlParameter('bottomtype'),
        bottomSizeParams = getUrlParameter('bottomsize');

    if (colourParams) {
        var colourParamsArray = colourParams.split('+');
        $.each(colourParamsArray, function(index,colour){
            $('.js-set-filter-colour[data-colour="' + colour + '"]').trigger('click');
        })
    }

    if (topTypeParams) {
        var topTypeParamsArray = topTypeParams.split('+');
        $.each(topTypeParamsArray, function(index,type){
            $('.js-set-filter-type-top[data-type="' + type + '"]').trigger('click');
        })
    }

    if (bottomTypeParams) {
        var bottomTypeParamsArray = bottomTypeParams.split('+');
        $.each(bottomTypeParamsArray, function(index,type){
            $('.js-set-filter-type[data-type="' + type + '"]').trigger('click');
        })
    }

    if (topSizeParams) {
        var topSizeParamsArray = topSizeParams.split('+');
        $.each(topSizeParamsArray, function(index,size){
            $('.js-set-filter-size-top[data-size="' + size + '"]').trigger('click');
        })
    }

    if (bottomSizeParams) {
        var bottomSizeParamsArray = bottomSizeParams.split('+');
        $.each(bottomSizeParamsArray, function(index,size){
            $('.js-set-filter-size-bottom[data-size="' + size + '"]').trigger('click');
        })
    }
}

function initMakeSetEvents() {
    var $productsBottom = $('#setBuilderBottom'),
        $productsTop = $('#setBuilderTop');

    $('.js-filter-containerinner').on('click', 'h4', function(){
        $(this).parent().toggleClass('is-active')
    });


    // Add to cart
    $('.js-makeset-addtocart').on('click', function(){
        var $parent = $(this).parents('.js-makeset-container'),
            $popup = $parent.find('.js-set-builder-cartpopup'),
            $swiper = $('#setProductsWrapper').find('.swiper-wrapper'),
            $swiperContainer = $('#setProductsWrapper').find('.swiper'),
            $overlay = $parent.find('.js-set-builder-cartoverlay'),
            variantId = $(this).attr('data-variant-id');

        window.qf_cart.addToCart(variantId, 1);

        setTimeout(function() {
            $swiperContainer.removeClass('is-popup-opened');
            $swiper.removeClass('is-popup-opened');
            $popup.addClass('is-hidden');
            $overlay.addClass('is-hidden');
        }, 2000)
    })

    var openSetPopup = function($el, isQuickView) {
        var $parent = $el.parents('.js-makeset-container'),
            $popup = $parent.find('.js-set-builder-cartpopup'),
            $swiper = $('#setProductsWrapper').find('.swiper-wrapper'),
            $swiperContainer = $('#setProductsWrapper').find('.swiper'),
            $quickViewContent = $parent.find('.js-set-quickview-content'),
            $image = $parent.find('.js-set-cartpopup-prodimg'),
            $overlay = $parent.find('.js-set-builder-cartoverlay');

        if (isQuickView) {
            console.log('here');
            var imageSrc = $image.data('src');
            $image.attr('src', imageSrc);
            $popup.addClass('is-quickview');
            $quickViewContent.removeClass('is-hidden');
        } else {
            $popup.removeClass('is-quickview');
            $quickViewContent.addClass('is-hidden');
        }

        $swiperContainer.addClass('is-popup-opened');
        $swiper.addClass('is-popup-opened');
        $popup.removeClass('is-hidden');
        $overlay.removeClass('is-hidden');
    }

    // Size select popup
    $('.js-makeset-selectsize').on('click', function() {
        openSetPopup($(this), false);
    });

    // Size select popup close
    $('.js-set-builder-cartpopup-close').on('click', function() {
        var $parent = $(this).parents('.js-makeset-container'),
            $popup = $parent.find('.js-set-builder-cartpopup'),
            $swiper = $('#setProductsWrapper').find('.swiper-wrapper'),
            $swiperContainer = $('#setProductsWrapper').find('.swiper'),
            $overlay = $parent.find('.js-set-builder-cartoverlay');

        $swiperContainer.removeClass('is-popup-opened');
        $swiper.removeClass('is-popup-opened');
        $popup.addClass('is-hidden');
        $overlay.addClass('is-hidden');
    });


    // Quick view popup open
    $('.js-set-product-quickview').on('click', function(){
        openSetPopup($(this), true);
    })

    $('.js-makeset-radio').on('click', function(){
        var $this = $(this),
            newId = $this.attr('data-variant-id'),
            $variant = $this.parents('.js-makeset-radiowrapper'),
            $parent = $this.parents('.js-makeset-product');

        $variant.siblings().removeClass('is-active');
        $variant.addClass('is-active');
        $parent.find('.js-makeset-addtocart').attr('data-variant-id', newId);
    });

    $('.js-set-filter-colour').on('click', function() {
        var $this = $(this),
            activeFilters = [],
            filterColour = $this.attr('data-colour');

        $this.toggleClass('is-active');

        // getting active filters
        $('.js-set-filter-colour').each(function(){
            var $colour = $(this);

            if ($colour.hasClass('is-active')) {
                activeFilters.push($colour.attr('data-colour'))
            }
        })


        $productsBottom.find('.js-makeset-product').each(function(){
            var $product = $(this),
                productPattern = $product.attr('data-pattern'),
                productColour = $product.attr('data-colour');

            if($.inArray(productColour, activeFilters) !== -1 || $.inArray(productPattern, activeFilters) !== -1 || activeFilters.length === 0) {
                $product.removeClass('is-hidden')
            } else {
                $product.addClass('is-hidden');
            }
        })

        $productsTop.find('.js-makeset-product').each(function(){
            var $product = $(this),
                productPattern = $product.attr('data-pattern'),
                productColour = $product.attr('data-colour');

            if($.inArray(productColour, activeFilters) !== -1 || $.inArray(productPattern, activeFilters) !== -1 ||  activeFilters.length === 0) {
                $product.removeClass('is-hidden')
            } else {
                $product.addClass('is-hidden');
            }
        })

        checkNotAvailableImages();
        showSetImages();
        updateDynamicMakeSetUrl();
    })

    // Sizes filter TOP
    $('.js-set-filter-size-top').on('click', function(){
        var $this = $(this),
            activeFilters = [],
            isActiveSize = $this.hasClass('is-active'),
            filterSize = $this.attr('data-size').toLowerCase();

        $this.parent().siblings().find('.js-set-filter-toggle').removeClass('is-active');

        if (isActiveSize) {
            $this.removeClass('is-active');
        } else {
            $this.addClass('is-active');
        }


        // getting active filters
        $('.js-set-filter-size-top').each(function(){
            var $filter = $(this);

            if ($filter.hasClass('is-active')) {
                activeFilters.push($filter.attr('data-size'))
            }
        })

        if (!isActiveSize) {
            // hide unavailable products
            $productsTop.find('.js-makeset-product').each(function(){
                var $product = $(this),
                    $sizeVariant = $product.find('[data-variantname="' + filterSize + '"]'),
                    productType = $product.attr('data-type');

                $product.removeClass('is-hidden-product');

                if ($sizeVariant.length == 0) {
                    $product.addClass('is-hidden-product');
                }
            })
        } else {
            $productsTop.find('.js-makeset-product').removeClass('is-hidden-product');
        }


        checkNotAvailableImages();
        showSetImages();
        updateDynamicMakeSetUrl();
    })

    // Sizes filter BOTTOM
    $('.js-set-filter-size-bottom').on('click', function(){
        var $this = $(this),
            activeFilters = [],
            isActiveSize = $this.hasClass('is-active'),
            filterSize = $this.attr('data-size').toLowerCase();

        $this.parent().siblings().find('.js-set-filter-toggle').removeClass('is-active');

        if (isActiveSize) {
            $this.removeClass('is-active');
        } else {
            $this.addClass('is-active');
        }

        // getting active filters
        $('.js-set-filter-size-bottom').each(function(){
            var $filter = $(this);

            if ($filter.hasClass('is-active')) {
                activeFilters.push($filter.attr('data-size'))
            }
        })

        if (!isActiveSize) {
            // hide unavailable products
            $productsBottom.find('.js-makeset-product').each(function(){
                var $product = $(this),
                    $sizeVariant = $product.find('[data-variantname="' + filterSize + '"]'),
                    productType = $product.attr('data-type');

                $product.removeClass('is-hidden-product');

                if ($sizeVariant.length == 0) {
                    $product.addClass('is-hidden-product');
                }
            })
        } else {
            $productsBottom.find('.js-makeset-product').removeClass('is-hidden-product');
        }


        checkNotAvailableImages();
        showSetImages();
        updateDynamicMakeSetUrl();
    })

    // Filter type TOP
    $('.js-set-filter-type-top').on('click', function(){
        var $this = $(this),
            activeFilters = [],
            filterType = $this.attr('data-type');

        $this.toggleClass('is-active');

        // getting active filters
        $('.js-set-filter-type-top').each(function(){
            var $filter = $(this);

            if ($filter.hasClass('is-active')) {
                activeFilters.push($filter.attr('data-type'))
            }
        })

        $productsTop.find('.js-makeset-product').each(function(){
            var $product = $(this),
                productType = $product.attr('data-type');

            if($.inArray(productType, activeFilters) !== -1 || activeFilters.length === 0) {
                $product.removeClass('is-hidden-product')
            } else {
                $product.addClass('is-hidden-product');
            }
        })

        checkNotAvailableImages();
        showSetImages();
        updateDynamicMakeSetUrl();
    })

    // Filter type BOTTOM
    $('.js-set-filter-type').on('click', function(){
        var $this = $(this),
            activeFilters = [],
            filterType = $this.attr('data-type');

        $this.toggleClass('is-active');

        // getting active filters
        $('.js-set-filter-type').each(function(){
            var $filter = $(this);

            if ($filter.hasClass('is-active')) {
                activeFilters.push($filter.attr('data-type'))
            }
        })

        $productsBottom.find('.js-makeset-product').each(function(){
            var $product = $(this),
                productType = $product.attr('data-type');

            if($.inArray(productType, activeFilters) !== -1 || activeFilters.length === 0) {
                $product.removeClass('is-hidden-product')
            } else {
                $product.addClass('is-hidden-product');
            }
        })

        checkNotAvailableImages();
        showSetImages();
        updateDynamicMakeSetUrl();
    })
}

function checkNotAvailableImages() {
    var bottomUnavailable = true,
        topUnavailable = true,
        $topMessage = $('#setBuilderTopNoResults'),
        $bottomMessage = $('#setBuilderBottomNoResults');

    $('#setBuilderBottom').find('.js-makeset-product').each(function(){
        if ($(this).hasClass('is-hidden') || $(this).hasClass('is-hidden-product')) {
        } else {
            bottomUnavailable = false;
        }
    })

    $('#setBuilderTop').find('.js-makeset-product').each(function(){
        if ($(this).hasClass('is-hidden') || $(this).hasClass('is-hidden-product')) {
        } else {
            topUnavailable = false;
        }
    })

    if (topUnavailable) {
        $topMessage.removeClass('is-hidden')
    } else {
        $topMessage.addClass('is-hidden')
    }

    if (bottomUnavailable) {
        $bottomMessage.removeClass('is-hidden')
    } else {
        $bottomMessage.addClass('is-hidden')
    }
}

function initMakeSetCarousels() {
    var setTopCarousel = new window.swiper("#setBuilderTop", {
        slidesPerView: 3,
        spaceBetween: 20,
        breakpoints: {
            768: {
                slidesPerView: 5,
                spaceBetween: 20,
            },
        },
        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    });

    setTopCarousel.on('slideChange', function (el) {
        showSetImages();
    });

    var setBottomCarousel = new window.swiper("#setBuilderBottom", {
        slidesPerView: 3,
        spaceBetween: 20,
        breakpoints: {
            768: {
                slidesPerView: 5,
                spaceBetween: 20,
            },
        },
        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    });


    setBottomCarousel.on('slideChange', function (el) {
        showSetImages();
    });
}

function showSetImages() {
    $('.js-set-prodimg').each(function(){
        var $this = $(this),
            newSrc = $this.data('src');
        $this.attr('src', newSrc);
    })
}

function initCollectionCustomNav() {
    var colectionTopNavCarousel = new window.swiper("#collectionTopNav", {
        slidesPerView: 3,
        spaceBetween: 10,
        breakpoints: {
            768: {
                slidesPerView: 5,
                spaceBetween: 10,
            },
        },
        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    });
}

function initYmalEvents() {
    $('#cart-drawer-container').on('click', '.js-ymal-close', function(){
        $('.ymal-container').removeClass('open');
    })
}

function initCollectionEvents() {
    $('.js-collection-heading').on('click', function(){
        $(this).toggleClass('is-active');
    })
}

function initReviewsAccordion() {
    $('.new-yotpo-small-box').on('click', function(){
        $(this).parents(".yotpo-display-wrapper").toggleClass('is-active');
    })

    $('.yotpo-display-wrapper').one('click', function(e){
        $(this).addClass('is-active');
    })

    $('.yotpo-nav-wrapper > span').html('Reviews');
}

function initChatBaseMobile() {
    $('#open-mobile-menu').on('click', function(){
        var $chat = $("#chatbase-bubble-button");
        $('#header-icons').append($chat);
        $chat.addClass('is-active');
        $chat.attr('role', 'button');
        $chat.attr('aria-label', 'button');
        $chat.attr('tabindex', '0');
    })
}

function initAnnouncmentBar() {
    var announcmentCarousel = new window.swiper("#announcmentBarNew", {
        slidesPerView: 1,
        loop: true,
        effect: "fade",
        autoplay: {
            delay: 3500,
        },
        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    });
}

function initClearAllFilters() {
    $('#clearAllFilters').on('click', function(){
        $('#qf-filter-wrapper .custom-filter-wrapper').find('input[type=checkbox]').each(function(){
            $(this).prop('checked', false).trigger("change");
        })
    })
}

function initHomepageCarousel() {
    var isFirefox = navigator.userAgent.toLowerCase().includes('firefox');

    if (isFirefox) {
        autoplaySettings = false
    } else {
        autoplaySettings = {
            delay: 10000,
            disableOnInteraction: false,
            pauseOnMouseEnter: false
        }
    }

    setTimeout(function(){
        var setHPCarousel = new window.swiper("#homepageCarouselWrapper", {
            slidesPerView: 1,
            autoplay: autoplaySettings,
            cache: false,
            direction: "horizontal",
            loop: false,
            hashNavigation: {
                watchState: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 1
                },
            },
            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            }
        });
    }, 100);
}

function initInlineUpsellEvents() {
    $('#addUpsellInlineToCart').on('click', function(){
        var id = $(this).data('id');
        window.qf_cart.addToCart(id, 1, {}, () => {
            setTimeout(function () {
                $('#productUpsellContainer').addClass('is-hidden');
            }, 1000);
        });
    })
}

function checkLowStock(size) {
    $('.js-swatch_wrapper').removeClass('is-low-stock is-no-stock');

    $('.js-swatch_wrapper').each(function(){
        var $this = $(this),
            variants = $this.data('variants'),
            variant = variants.split('::');

        $.each(variant, function(key, value){
            var data = value.split(';'),
                variantSize = data[4],
                stock = parseInt(data[3]);
            if (variantSize == size) {
                if (stock < 1) {
                    $this.addClass('is-no-stock')
                } else if (stock < 4) {
                    $this.addClass('is-low-stock')
                } else {
                    $this.removeClass('is-low-stock is-no-stock');
                }
            }
        })
    })
}

function initLowStockSwatches() {
    var selectedSize = $('.variant-sizes').find('.variant-radios:checked').data('title');

    if (selectedSize) {
        checkLowStock(selectedSize);
    }
}

function initBestsellersCarousel() {
    var setHPCarousel = new window.swiper(".js-bestsellers-slider-wrapper", {
        slidesPerView: 2.6,
        spaceBetween: 15,
        slidesOffsetBefore: 20,
        loop: true,
        breakpoints: {
            768: {
                slidesPerView: 4.6,
                slidesOffsetBefore: 60
            },
        },
        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: ".swiper-pagination",
        }
    });
}

function initCategoryListCarousel() {

    var setHPCarousel = new window.swiper(".js-category-slider-wrapper", {
        slidesPerView: 2.6,
        spaceBetween: 15,
        slidesOffsetBefore: 20,
        loop: true,
        breakpoints: {
            768: {
                slidesPerView: 5.6,
                slidesOffsetBefore: 60
            },
        },
        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: ".swiper-pagination",
        }
    });
}

function initCollectionGridCarousel() {
  var isDesktop = $(window).width() > 1000;
  var isTablet = $(window).width() > 768 && $(window).width() <= 1000;

  if (isDesktop) {
     var setCollectionGridCarousel = new window.swiper(".js-collection-grid-carousel", {    
        slidesPerView: 5.9,
        spaceBetween: 15,
        slidesOffsetBefore: 20,
        loop: false,
        breakpoints: {
            1440: {
                slidesPerView: 7.9,
                slidesOffsetBefore: 60
            },
            1140:{
                slidesPerView: 6.9,
                slidesOffsetBefore: 60
            }
        },
        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: ".swiper-pagination",
        },
        on: {
        init: function () {
          $('#collection-grid').addClass('is-carousel-initialized')
        }
      },
    }); 
  }
  if (isTablet) {
     var setCollectionGridCarousel = new window.swiper(".js-collection-grid-carousel", {    
        slidesPerView: 4.2,
        spaceBetween: 15,
        slidesOffsetBefore: 20,
        loop: false,
        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: ".swiper-pagination",
        },
        on: {
        init: function () {
          $('#collection-grid').addClass('is-carousel-initialized')
        }
      },
    }); 
  }
  
}

function initSplitContainersHref() {
    $('.js-split-image-banner-block').on('click', function(){
        var href = $(this).data('href');
        window.location.href = href;
    })
}

function initCartUpsell() {
    var makeSetItemsList = [],
        productsArray = [],
        requestAmount = 0;

    $('.js-minicart-item').each(function() {
        var makesetItems = $(this).data('makeset').split(';');
        $.each(makesetItems, function( key, value ) {
            makeSetItemsList.push(value);
        });
    });

    $.each(makeSetItemsList, function( key, value ) {
        axios.get(value)
            .then(function (response) {
                // Success
                productsArray.push(response.data);
                requestAmount++;

                if (requestAmount == makeSetItemsList.length) {
                    var newProductsArray = sortMinicartSetProducts(makeSetItemsList,productsArray);

                    //initMinicartSetProducts(newProductsArray);
                    initMinicartSetProductsCarousel();
                    // var newProductsArray = sortSetProducts(productsList, productsArray);

                    // initSetProducts(newProductsArray);
                    // initSetProductsCarousel(newProductsArray);
                    // initSetCountry();
                }
            })
    });
}

function sortMinicartSetProducts(productsListOld, productsListNew) {
    var sortedProductsList = [];

    $.each(productsListOld, function(index, productHandle) {
        var productHandleOld = productHandle.split('/products/')[1],
            productsHandleOld2 = productHandleOld.split('?')[0];

        $.each(productsListNew, function(index2, productObj) {
            var productObjHandle = productObj.url.split('/products/')[1];

            if (productObjHandle == productsHandleOld2) {
                sortedProductsList.push(productObj);
            }
        });

    })

    return sortedProductsList;
}

function initMinicartSetProductsCarousel() {
    var freq_swiper = new window.swiper(".freq-desktop-cart", {
        slidesPerView: 1.2,
        spaceBetween: 16,
        breakpoints: {
            768: {
                slidesPerView: 1.2,
                spaceBetween: 16,
            },
        },
        loop: false,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    });
    $('.swiper-arrow').on('click', function(f){
        f.preventDefault();
        freq_swiper.slideNext();
    })     
    cartUpsellItemsMultiBuyPrice();          
}

function initMinicartSetProducts(setProducts) {
    var t = document.getElementById("main-product-container"),
        showAllProducts = $('#makeSetWrapper').data('showall');

    if (t) {
        var n = setProducts;

        var a = document.querySelector(".cart-frequently-bought-desktop"),
            i = document.querySelector(".cart-frequently-bought.swiper-wrapper");
        a.innerHTML = "";
        i.innerHTML = "";
        for (var d = 0; d < n.length; d++) {
            //var e = n[d].price / 100, r = n[d].compare_at_price;
            var e = n[d].price, r = n[d].compare_at_price;
            var priceOrigin = parseInt(e.replace(/[^0-9]/gi, ''));
            var priceCompare = parseInt(r);

            if (showAllProducts == "true" || ( showAllProducts == false && (priceCompare == 0 || priceCompare == priceOrigin))) {
                null == r || 0 == r ? r = "" : (r /= 100, r = "<span class='strikethrough' style='margin-right:5px' id='compare-price-".concat(n[d].id, "'>£").concat(r.toFixed(2), "</span>"));
                var c = n[d].id, o = n[d].variants;
                freq_v = [];
                for (var s = 0; s < o.length; s++) 1 == o[s].available && (freq_v += '\n                        <div class="freq-variant-radio-container">\n                            <input class="freq-variant-radios" type="radio" data-prod-id="'.concat(c, '" id="v-radio-').concat(o[s].id, '" name="id-').concat(c, '" value="').concat(o[s].id, '">\n                            <label for="v-radio-').concat(o[s].id, '">\n                                ').concat(o[s].title, "\n                            </label>\n                        </div>\n                        "));

                n[d].tags.includes("Subscription") ? (window.log("HAS SUBSCRIPTION TAG", n[d].tags), a.innerHTML += '\n         <div class="swiper-slide">\n             <div class="freq-product-card makeset-product-card">\n                    <div class="button-wishlist"><button data-product="'.concat(n[d].id, '" data-variant="').concat(n[d].variants[0].id, '"></button></div>\n  <div class="makeset-label">').concat(n[d].setDiscount, '</div>\n                   <a href="').concat(n[d].url, '" class="freq-product-img">\n                            <img src="').concat(n[d].featured_image, '" alt="" />\n                        </a>\n                        <div class="freq-product-info">\n                            <div class="freq-product-title">\n                            <a href="').concat(n[d].url, '">').concat(n[d].title, '</a>\n                            </div>\n                            <div class="freq-product-price">\n                                <div>').concat(r, '<span class="product-price f-b-price">').concat(e, '</span></div>\n                            </div>\n                        </div>\n                        <div class="freq-product-button">\n                            <a class="button-2" href="').concat(n[d].url, '">view</a>\n                        </div>\n                    </div>\n                '), i.innerHTML += '\n                    <div class="swiper-slide">\n                        <div class="freq-product-card makeset-product-card">\n                        <div class="button-wishlist"><button data-product="'.concat(n[d].id, '" data-variant="').concat(n[d].variants[0].id, '"></button></div>\n         <div class="makeset-label">').concat(n[d].setDiscount, '</div>\n                   <div class="freq-product-img">\n                            <img src="').concat(n[d].featured_image, '" alt="" />\n                            </div>\n                            <div class="freq-product-info">\n                                <div class="freq-product-title">\n                                    ').concat(n[d].title, '\n                                </div>\n                                <div class="freq-product-price">\n                                    <div>').concat(r, '<span class="product-price f-b-price">').concat(e, '</span></div>\n                                </div>\n                            </div>\n                            <div class="freq-product-button">\n                                <a class="button-2" href="').concat(n[d].url, '">view</a>\n                            </div>\n                        </div>\n                    </div>\n                ')) : (window.log("HAS NOT GOT SUBSCRIPTION TAG", n[d].tags), a.innerHTML += '\n        <div class="swiper-slide">\n              <div class="freq-product-card makeset-product-card">\n                    <div class="button-wishlist"><button data-product="'.concat(n[d].id, '" data-variant="').concat(n[d].variants[0].id, '"></button></div>\n       <div class="makeset-label">').concat(n[d].setDiscount, '</div>\n                 <a href="').concat(n[d].url, '" class="freq-product-img">\n                            <img src="').concat(n[d].featured_image, '" alt="" />\n                        </a>\n                        <div class="freq-product-info">\n                            <div class="freq-product-title">\n                            <a href="').concat(n[d].url, '">').concat(n[d].title, '</a>\n                            </div>\n                            <div class="freq-product-price">\n                                <div>').concat(r, '<span class="product-price f-b-price">').concat(e, '</span></div>\n                            </div>\n                            <div class="freq-product-variants">\n                                ').concat(freq_v, '\n                            </div>\n                        </div>\n                        <div class="freq-product-button">\n                            <button class="button button-2" id="').concat(c, '" data-variant-id="">add to basket</button>\n                        </div>\n                    </div>\n                '), i.innerHTML += '\n                    <div class="swiper-slide">\n                        <div class="freq-product-card">\n                        <div class="button-wishlist"><button data-product="'.concat(n[d].id, '" data-variant="').concat(n[d].variants[0].id, '"></button></div>\n   <div class="makeset-label">').concat(n[d].setDiscount, '</div>\n                        <div class="freq-product-img">\n                            <img src="').concat(n[d].featured_image, '" alt="" />\n                            </div>\n                            <div class="freq-product-info">\n                                <div class="freq-product-title">\n                                    ').concat(n[d].title, '\n                                </div>\n                                <div class="freq-product-price">\n                                    <div>').concat(r, '<span class="product-price f-b-price">').concat(e, '</span></div>\n                                </div>\n                                <div class="freq-product-variants">\n                                    ').concat(freq_v, '\n                                </div>\n                            </div>\n                            <div class="freq-product-button">\n                                <button id="mob-').concat(c, '" data-variant-id="">add to basket</button>\n                            </div>\n                        </div>\n                    </div>\n                '))
            }
        }
        for (var l = document.querySelectorAll(".freq-desktop .freq-variant-radios"), v = function (t) {
            l[t].addEventListener("click", (function () {
                var n = l[t].value, a = l[t].getAttribute("data-prod-id");
                window.log("PRODUCT ID", a), document.getElementById(a).setAttribute("data-variant-id", n), document.getElementById(a).innerHTML = "add to basket"
            }))
        }, u = 0; u < l.length; u++) v(u);
        for (var p = document.querySelectorAll(".freq-desktop .freq-product-button button"), f = 0; f < p.length; f++) p[f].addEventListener("click", (function () {
            window.log("CLICKED", this.getAttribute("data-variant-id")), var_id = this.getAttribute("data-variant-id"), var_id ? window.qf_cart.addToCart(var_id, 1) : this.innerHTML = "please select a size"
        }));
        for (var b = document.querySelectorAll(".freq-swiper .freq-variant-radios"), q = function (t) {
            b[t].addEventListener("click", (function () {
                var n = l[t].value, a = l[t].getAttribute("data-prod-id");
                window.log("VARIANT ID", a), window.log("BUTTON", document.getElementById(a)), document.getElementById("mob-" + a).setAttribute("data-variant-id", n), document.getElementById("mob-" + a).innerHTML = "add to basket"
            }))
        }, g = 0; g < b.length; g++) q(g);
        for (var w = document.querySelectorAll(".freq-swiper .freq-product-button button"), m = 0; m < w.length; m++) w[m].addEventListener("click", (function () {
            window.log("CLICKED", this.getAttribute("data-variant-id")), var_id_mobile = this.getAttribute("data-variant-id"), var_id_mobile ? window.qf_cart.addToCart(var_id_mobile, 1) : this.innerHTML = "please select a size"
        }))
    }
}

function initCartCarousel() {
    var setMinicartMessages = new window.swiper("#minicartMessages", {
        slidesPerView: 1,
        loop: true,
        autoplay: {
            delay: 3000,
        }
    });
}

function detectBrowsers() {
    var safariAgent = /^((?!chrome|android).)*safari/i.test(navigator.userAgent),
        firefoxAgent = /^((?!chrome|android).)*firefox/i.test(navigator.userAgent),
        isMobile = $(window).width() < 1000;

    if ((safariAgent || firefoxAgent) && !isMobile) {
        $('body').addClass('is-browser-safari')
    }
}

function initVideoEvents() {
    $('.js-swiper-video').on('click', function(){
        $(this).parent().removeClass('product-video-wrapper');
    });

    $('.js-play-productvideo').on('click', function(){
        // $('.js-swiper-video').get(0).load();
        // $('.js-swiper-video').get(0).play();

        var swiper = document.querySelector('.gallery-swiper').swiper,
            swiperLength = swiper.slides.length - 2;

        swiper.slideToLoop(-1, 0)

        $('html, body').animate({scrollTop: 0}, 0);
    })
}

function initMultipleProductsAdding() {
    $('.js-addtocart-multiple').on('click', function(){
        var quantity = $(this).data('quantity'),
            activeId = $('#variantRadioWrapper').find('input[name=id]:checked').val()

        if (activeId) {
            window.qf_cart.addToCart(activeId, quantity);
        }

    })
}

function initLibraryChatBase() {
    var existingScript = document.getElementById('#chatbase-message-bubbles');

    if (!existingScript) {
        window.chatbaseConfig = {
            chatbotId: "3R6GCziMQh_5rs-rXm6pe",
        }

        var script = document.createElement('script');
        script.src = 'https://www.chatbase.co/embed.min.js';
        script.id = '3R6GCziMQh_5rs-rXm6pe';
        script.defer = 'defer';
        script.async = true
        document.body.appendChild(script);
    }
}

function initLibrariesLazyLoading() {
    var chatBaseInitialized = false
    $(document).on('scroll', function () {
        var scrollTop = $(this).scrollTop();

        if (scrollTop > 50 && !chatBaseInitialized) {
            chatBaseInitialized = true;
            setTimeout(function () {
                initLibraryChatBase();
            }, 1000);
        }
    })
}

function initImagesLazyLoading() {
    var footerReviewsLoaded = false;
    $(document).on('scroll', function () {
        var scrollTop = $(this).scrollTop();
        if (!footerReviewsLoaded && scrollTop > 2500) {
            $('.js-review-slider-img').find('img').each(function(){
                $(this).attr('loading', 'eager');
            })

            footerReviewsLoaded = true;
        }
    });
}

function initTabsSections() {
    $('.js-tabs-heading').on('click', function(){
        var $this = $(this),
            tabName = $this.data('tab');

        // toggle active header
        $this.siblings().removeClass('is-active');
        $this.addClass('is-active');

        // toggle active content
        $('.js-tabs-content').removeClass('tabs-content-active');
        $('.js-tabs-content[data-tab="' + tabName + '"').addClass('tabs-content-active');
    })
}

function initReviewsIoEvents() {
    $('.ruk_rating_snippet').on('click', function(){
        var scrollOffset = $('#ReviewsWidget').offset().top - 180;
        $(window).scrollTop(scrollOffset)
    })
}

function initMinicartWishlist() {

    window.addEventListener('side_cart_opened', function(){
        if (typeof ReloadSmartWishlist !== "undefined" && $.isFunction(ReloadSmartWishlist)) {
            ReloadSmartWishlist();
        }
    });
}

function initGridHeaderEvents() {
    $('#collection-grid').on('click', '.size-label', function(e){
        var $this = $(this),
            url = $this.attr('href'),
            listingId = $this.data('listing-id');

        // && $(window).width() > 1000
        if (listingId != "") {
            e.preventDefault();

            history.pushState(
                {...history.state,category_current_listing_query: { id: listingId, type: "listingId" } },
                "",
                url)
        }
    })
}

function initShopTheLook() {
  $(function() {
      var modal = $('#shop-the-look-modal');
      var imgEl = $('#shop-the-look-modal-img');
      var shopContainer = $('.shop-the-look__links--shop');
      var likeContainer = $('.shop-the-look__links--like');

      $('.shop-the-look__item').on('click', function() {
          var $this = $(this);
          imgEl.attr('src', $this.data('image-src'));
          shopContainer.empty(); likeContainer.empty();
          // Render products
          ['shop','like'].forEach(function(type) {
              var container = type === 'shop' ? shopContainer : likeContainer;
              for (var i=1; i<=2; i++) {
                  var key = type + i;
                  var url = $this.data(key + 'Url');
                  var title = $this.data(key + 'Title');
                  var img = $this.data(key + 'Image');
                  var price = $this.data(key + 'Price');
                  var tagsHtml = $this.data(key + 'TagsHtml');
                  var picker = $this.data(key + 'Picker');
                  if (url && title) {
                      var badge = picker === 'true' ? '<span class="shop-the-look__badge">knicker-picker</span>' : '';
                      container.append(
                          '<a href="'+url+'">'+
                          '<div class="shop-the-look__image-wrapper">'+
                          '<img src="'+img+'" alt="'+title+'" />'+
                          '<div class="button-wishlist"><button class="smartwishlist" aria-label="Add to wishlist" data-product="'+$this.data(key + 'ProductId')+'" data-variant="'+$this.data(key + 'VariantId')+'"></button></div>'+
                          '</div>'+
                          badge +
                          '<div class="shop-the-look__tags">'+tagsHtml+'</div>'+
                          '<span>'+title+'</span>'+
                          '<div class="shop-the-look__price">'+price+'</div>'+
                          '</a>'
                      );
                  }
              }
          });
        
          if (typeof ReloadSmartWishlist !== "undefined" && $.isFunction(ReloadSmartWishlist)) {
              ReloadSmartWishlist();
          }
          modal.fadeIn(200);
      });
      $('.shop-the-look__modal-close, .shop-the-look__modal').on('click', function(e){ if(e.target===this) modal.fadeOut(200); });
  });
}

function changeKlarnaPlacement() {
  var isProductPage = $('body').hasClass('template-product');

  if (isProductPage) {
     $('klarna-placement').appendTo('#klarnaPaymentsWrapperNew');    
  } 
}

function initApp() {
    $('document').ready(function () {
        initMinicartEvents();
        initCustomFilterEvents();
        initPdpSwatches();
        initPdpTabs();
        initSwatchCollapse();
        setFlagPosition();
        initMakeSetEvents();
        initMakeSetCarousels();
        initNotifyMeEvents();
        initMakeSetUrls();
        initCollectionCustomNav();
        initCollectionEvents();
        initYmalEvents();
        initChatBaseMobile();
        initAnnouncmentBar();
        initClearAllFilters();
        initHomepageCarousel();
        initInlineUpsellEvents();
        initLowStockSwatches();
        initCategoryListCarousel();
        initBestsellersCarousel();
        initSplitContainersHref();
        initMakeASet();
        detectBrowsers();
        initVideoEvents();
        initMultipleProductsAdding();
        //initLibrariesLazyLoading();
        initImagesLazyLoading();
        // setFlagEvents();
        initTabsSections();
        initReviewsIoEvents();
        initMinicartWishlist();
        initCollectionGridCarousel();
        initShopTheLook();
        changeKlarnaPlacement();
        quantitySelector();
        // initGridHeaderEvents();
        $('.js-hero-clickable').on('click', function(){
            var link = $(this).data('href');
            window.location.href = link;
        })


        // window.dispatchEvent(side_cart_opened_event);
        videowise_widget();

        // Initial size-caption sync on page load - use same logic as variant change
        try {
            var initialThumbnailLabel = $('.js-swatch_wrapper.current').data('thumbnail-label') || $('#colourwaysList .js-swatch_wrapper').first().data('thumbnail-label') || '';
            if (console && console.log) {
                console.log('Main app initial load - thumbnailLabel:', initialThumbnailLabel);
            }
            if (initialThumbnailLabel) {
                // Wait for swiper to be ready with multiple attempts
                var attemptSync = function(attempts) {
                    attempts = attempts || 0;
                    var swiperEl = document.querySelector('.gallery-swiper');
                    if (swiperEl && swiperEl.swiper) {
                        // Store the initial thumbnail label in swiper
                        swiperEl.swiper.thumbnailLabel = initialThumbnailLabel;
                        
                        if (console && console.log) {
                            console.log('Main app - swiper ready, setting up initial load');
                        }
                        
                        // Use the global updateOverlayContent function with delay
                        if (window.updateOverlayContent) {
                            setTimeout(function() {
                                if (console && console.log) {
                                    console.log('Main app - calling updateOverlayContent');
                                }
                                // Update overlay content directly (updateReviewOverlay not available yet)
                                window.updateOverlayContent();
                                
                                // Trigger gallery-swiper slideChange event (same as variant change)
                                if (swiperEl.swiper && swiperEl.swiper.emit) {
                                    if (console && console.log) {
                                        console.log('Main app - triggering gallery-swiper slideChange event');
                                    }
                                    swiperEl.swiper.emit('slideChange');
                                }
                            }, 100);
                        }
                        
                        // Note: slide change listener is already set up in the main overlay logic
                        // No need to duplicate it here
                    } else if (attempts < 10) {
                        // Retry if swiper not ready yet
                        setTimeout(function() { attemptSync(attempts + 1); }, 200);
                    }
                };
                attemptSync();
            } else {
                // No thumbnail label, hide overlay
                if (console && console.log) {
                    console.log('Main app - no thumbnail label, hiding overlay');
                }
                if (window.innerWidth <= 769) {
                    $('.pdp-review-overlay-wrapper').addClass('is-hidden').hide();
                }
            }
        } catch(e) { 
            if (console && console.warn) { console.warn('initial size-caption sync failed', e); }
            // Hide overlay on error
            if (window.innerWidth <= 769) {
                $('.pdp-review-overlay-wrapper').addClass('is-hidden').hide();
            }
        }
    })

    $(window).on('load', function() {
        // setFlagEvents();
        initReviewsAccordion();

        // Fallback: Ensure size-caption is synced after everything loads
        try {
            var fallbackThumbnailLabel = $('.js-swatch_wrapper.current').data('thumbnail-label') || $('#colourwaysList .js-swatch_wrapper').first().data('thumbnail-label') || '';
            if (fallbackThumbnailLabel) {
                var swiperEl = document.querySelector('.gallery-swiper');
                if (swiperEl && swiperEl.swiper) {
                    // Use same index logic as product-img-caption: activeIndex (0-based) matches labelOrder (1-based)
                    var currentIndex = swiperEl.swiper.activeIndex || 0;
                    var captionText = '';
                    var partsList = fallbackThumbnailLabel.split(';');
                    $.each(partsList, function(i, item){
                        if (item) {
                            var parts = item.split(':'),
                                text = $.trim((parts[0] || '')),
                                order = parseInt($.trim((parts[1] || '')), 10);
                            // Match the same logic as product-img-caption: order == index (0-based)
                            if (order == currentIndex) { captionText = text; }
                        }
                    });
                    // Update overlay content dynamically (mobile only)
                    if (window.innerWidth <= 769) {
                    var $overlayWrapper = $('.pdp-review-overlay-wrapper');
                        var $sizeCaptionSlide = $('.size-caption-slide');
                        var $sizeCaption = $('.size-caption');
                        var $reviewSwiper = $('.review-overlay-swiper');
                        var $reviewSlides = $('.review-overlay-swiper .swiper-slide:not(.size-caption-slide)');
                        
                        // Check if there are any review slides (excluding caption slide)
                        var hasReviews = $reviewSlides.length > 0;
                        var hasCaption = captionText && captionText.trim() !== '';
                        
                        // Only show overlay if there's content to show
                        if (hasCaption || hasReviews) {
                    $overlayWrapper.removeClass('is-hidden').show();
                    
                            // Handle caption slide
                            if ($sizeCaptionSlide.length > 0) {
                                if (hasCaption) {
                                    // Show caption slide when caption exists
                                    $sizeCaption.text(captionText);
                        $sizeCaptionSlide.removeClass('is-hidden').show();
                    } else {
                                    // Remove caption slide completely when no caption
                                    $sizeCaptionSlide.remove();
                                }
                    }
                    
                            // Show review swiper if there are reviews
                            if (hasReviews) {
                    $reviewSwiper.removeClass('is-hidden').show();
                                
                                // Update overlay swiper to reflect changes
                                var overlaySwiper = $reviewSwiper[0]?.swiper;
                                if (overlaySwiper) {
                                    overlaySwiper.update();
                                }
                            }
                        } else {
                            // Hide entire overlay when no content
                            $overlayWrapper.addClass('is-hidden').hide();
                        }
                    }
                }
            }
        } catch(e) { if (console && console.warn) { console.warn('fallback size-caption sync failed', e); } }

        var countryFlag = $('.gep-switcher-flag').css('background-image');

        $('.tooltipFlag').css('background-image', countryFlag);

    })
}

//Eco Lace video wise 

function isAllowedCollectionTemplate() {

//   var bodyCls = document.body.className || "";
//   if (/(^|\s)template-collection[-_.]eco-lace(\s|$)/i.test(bodyCls)) return true;


//   var markerSel = [
//     '[data-template*="eco-lace"]',
//     '[data-template-suffix*="eco-lace"]',
//     '[data-section-type*="eco-lace"]',
//     '[id*="eco-lace"]',
//     '[class*="eco-lace"]'
//   ].join(',');
//   if (document.querySelector(markerSel)) return true;

//   // Some themes use ?view=eco-lace
//   var params = new URLSearchParams(location.search);
//   if (params.get('view') === 'eco-lace') return true;

  return false;
}

var VW_SELECTORS =
  '.custom-vw-widget, [data-videowise], .videowise-embed, #videowise_widget, iframe[src*="videowise"]';

function hideOrShowVWWidgets(shouldShow) {
  document.querySelectorAll(VW_SELECTORS).forEach(function(el){
    el.style.display = shouldShow ? '' : 'none';
  });
}

function videowise_widget(){
  // apply immediately
  hideOrShowVWWidgets(isAllowedCollectionTemplate());

  // re-apply on SPA-ish navigation
  window.addEventListener('popstate', function(){ hideOrShowVWWidgets(isAllowedCollectionTemplate()); });
  document.addEventListener('shopify:section:load', function(){ hideOrShowVWWidgets(isAllowedCollectionTemplate()); });
  document.addEventListener('page:load', function(){ hideOrShowVWWidgets(isAllowedCollectionTemplate()); }); // Turbo/Turbolinks

  // Guard against late injections & route changes
  if (!window.__vwObserver) {
    window.__vwObserver = new MutationObserver(function(mutations){
      var allowed = isAllowedCollectionTemplate(); 
      var enforce = false;

      mutations.forEach(function(m){
        m.addedNodes.forEach(function(n){
          if (n.nodeType !== 1) return;
          if ((n.matches && n.matches(VW_SELECTORS)) || (n.querySelector && n.querySelector(VW_SELECTORS))) {
            enforce = true;
          }
        });
      });

      if (enforce) hideOrShowVWWidgets(allowed);
    });

    window.__vwObserver.observe(document.documentElement, { childList: true, subtree: true });
  }
}

function quantitySelector() {
    const plus = document.querySelector('.plus-qty');
    const minus = document.querySelector('.minus-qty');
    const quantitySelector = document.querySelector('.quantity-selector');
    const submitBtn = document.querySelector('[data-submit-btn]');

    function showHide() {
        if (parseInt(quantitySelector.value) < 2) {
            submitBtn.classList.add('is-hidden');
        } else {
            submitBtn.classList.remove('is-hidden');
        }
    }

    plus?.addEventListener('click', () => {
        if(quantitySelector.max <= parseInt(quantitySelector.value)) return;
        quantitySelector.value = parseInt(quantitySelector.value) + 1;
        const qtyNumber = submitBtn.querySelector('.quantity-number')
        if (qtyNumber) {
            qtyNumber.textContent = `${parseInt(quantitySelector.value)}`;
        }
        if(document.querySelector('multi-buy').classList.contains('is-hidden')) {
            console.log('Hidden Multibuy')
            const price = document.querySelector('.submit-button.button-2 .multi-buy-price');
            if(price) {
                price.textContent = '£'+(parseFloat(price.dataset.price) * parseInt(quantitySelector.value)).toFixed(2).replace('.00', '');
            }
        }
        window.dispatchEvent(new CustomEvent('quantity-selector-changed', { detail: { value: quantitySelector.value } }));
    });
    minus?.addEventListener('click', () => {
        if(parseInt(quantitySelector.value) <= 1) return;
        quantitySelector.value = parseInt(quantitySelector.value) - 1;
        const qtyNumber = submitBtn.querySelector('.quantity-number')
        if (qtyNumber) {
            qtyNumber.textContent = `${parseInt(quantitySelector.value)}`;
        }
        if(document.querySelector('multi-buy').classList.contains('is-hidden')) {
            const price = document.querySelector('.submit-button.button-2 .multi-buy-price');
            if(price) {
                price.textContent = '£'+(parseFloat(price.dataset.price) * parseInt(quantitySelector.value)).toFixed(2).replace('.00', '');
            }
        }
        window.dispatchEvent(new CustomEvent('quantity-selector-changed', { detail: { value: quantitySelector.value } }));
    }); 
}


function submitButton() {
    const submitBtns = document.querySelectorAll('button.button-2');
    submitBtns.forEach((submitBtn) => {
        submitBtn.addEventListener('click', () => {
        });
    });
}
window.addEventListener('cart_rendered', function () {
    fetch('/cart.js')
        .then(function (res) {
        return res.json();
        })
        .then(function (cart) {
        if(cart.item_count > 0){
            document.querySelector('#cart-drawer').classList.remove('empty__cart');
        }else{
            document.querySelector('#cart-drawer').classList.add('empty__cart');
        }
        })
        .catch(function (err) {
        console.error('Cart fetch error:', err);
    });
});